import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import bus from '../../../../ask/eventBus';
import { getCookie } from '../../../../ask/cookiejs'
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import CommonInvoiceInput from '../../../../components/userCenter/public/CommonInvoiceInput.vue'
import claim from '../../../../components/userCenter/public/claimClause.vue' //理赔条款
import battery from '../../../../components/userCenter/public/batteryType.vue' //电池种类说明
import { fileSteamDownload } from '@/utils/download'
export default {
  components: { menberMenu, CommonInvoiceInput, claim, battery },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: "Express shipment,Booking",
      titUrls: "/exp/expList,",

      myHeaders: {
        ['X-JWT-TOKEN']: getCookie('X-BY-EnTOKEN')
      },

      ////-------------------第一部分基础信息---------------------///////
      EditOrderReqEn: {
        WaybillNO: '', ChannelKey: '',
        StartCityKey: '', StartCityName: '', StartCityNameEn: '',
        DestCountrKey: '', DestCountryName: '', DestCountryNameEn: '',
        workDay: '',//参考时效  
        THworkDay: '',//取件时效
        PackageType: null,//包裹类型。1：包裹，2：文件 ,
        RefNO: '', //参考号
        ModeCode: '',//运输方式
        BaseModeCode: '', //运输方式大类
        CargoIDs: '',//货物种类ID集合
        CargoDescs: '',//货物种类说明
        InsideBattery: 0,//内置电池类型
        MatingBattery: 0,//配套电池类型
        BatteryCountType: '',//含电池个数
        BatterySelectInfo: null,//有无电池资料  
        OrderChargeWeight: null,// 下单计费重 
        OrderCount: null,//下单件数 , 
        OrderWeight: null,// 下单实重 
        OrderVolume: null,//下单体积, 
        InvoiceType: null,//发票类型。2：随货纸质发票，3：上传电子发票，4：在线制作发票 , 
        CusInvoiceInfoID: '',//我的发票ID。传我的发票ID进来，根据ID,把数据存到订单发票信息中。我的发票包含收发件人信息，产品信息，外币信息和发票基本信息 ,
        ConsigneeID: 0,// 收件人id ,
        EORI: '',//
        Remark: '',//备注
        Currency: 2,//2:美元，1：人民币
        BatteryRequired: '',//是否有电池资料信息
      },

      //货物信息内置电池，配套电池下拉内容
      cargoInfo: {
        InsideBatOptions: [
          // {InsideBattery:0,label:'type of built-in batteries',},
          { InsideBattery: 10, label: 'Built-in lithium ion batteries', },
          { InsideBattery: 11, label: 'Built-in lithium metal batteries', }
        ],
        MatingBatOptions: [
          // {MatingBattery:0,label:'type of batteries packed with equipment',},
          { MatingBattery: 18, label: 'Lithium ion batteries packed with equipment' },
          { MatingBattery: 19, label: 'Lithium metal batteries packed with equipment' },
          { MatingBattery: 17, label: 'Dry batteries packed with equipment' }
        ],
      },
      ////-------------------产品信息列表---------------------///////产品信息列表
      OrderProductInfos: [
        {
          Id: '',
          EnglishName: '', //英文品名
          Material: '', //材质
          Purpose: '',//用途
          CustomsCode: '',//海关编码
          Quanlity: 0,//数量
          Price: 0,//单价
          Unit: 1,
        }
      ],
      ////-------------------发票信息---------------------/////
      InvoiceInfoPage: {
        invTypeInfo: [],//发票类型显示数组 {InvoiceTypeID:2},{InvoiceTypeID:3},{InvoiceTypeID:4}
        invTemplateChk: '',//选择发票的名称
        TemplateInvoicePath: '', //已经选中的发票模板路径
      },
      InvoiceInfo: {}, //发票信息
      invoiceBackup: {},//备份一份点击发票编辑保存按钮时的数据

      ////-------------------电池资料上传---------------------////
      OrderUploadFilesInfos: [],
      fileNum: 20, //电池资料上传限制最大个数
      upLoadData: {
        PathName: 'exp/order',
        IsTempFile: false
      },//导入文件

      ////-------------------快递订单shipper信息---------------------/////
      Shipper: { //发件人
        Company: '', ContactName: '', ContactTel: '', ZipCode: '', Email: '', CountryKey: '', Country: '', ProvinceKey: '',
        Province: '', CityKey: '', City: '', Address: '',
      },
      ////-------------------包裹联系人信息包含我的发票中联系人---------------------/////
      OrderContactInfos: {
        //收件人
        Consignee: '', ConsigneeCompany: '', ConsigneeTel: '', ConsigneeEmail: '', ConsigneeZipcode: '',
        ConsigneeCountryKey: '', ConsigneeCountry: '', ConsigneeCity: '', ConsigneeAddress: '', ConsigneeID: 0,
        //发件人
        Consignor: '', ConsignorCompany: '', ConsignorTel: '', ConsignorEmail: '', ConsignorZipcode: '',
        ConsignorCountry: '', ConsignorProvince: '', ConsignorProvinceKey: '',
        ConsignorCity: '', ConsignorCityKey: '', ConsignorAddress: '', ConsignorID: '',
      },

      ////-------------------文件联系人信息包含我的发票中联系人---------------------/////
      OrderDocInfos: {
        //收件人
        Consignee: '', ConsigneeCompany: '', ConsigneeTel: '', ConsigneeEmail: '', ConsigneeZipcode: '',
        ConsigneeCountryKey: '', ConsigneeCountry: '', ConsigneeCity: '', ConsigneeAddress: '', ConsigneeID: 0,
        //发件人
        Consignor: '', ConsignorCompany: '', ConsignorTel: '', ConsignorEmail: '', ConsignorZipcode: '',
        ConsignorCountry: 'China', ConsignorCountryKey: '3c48f3d4-8f99-4721-9e88-2ff6f77b10bf', ConsignorProvince: '', ConsignorProvinceKey: '',
        ConsignorCity: '', ConsignorCityKey: '', ConsignorAddress: '', ConsignorID: '',
      },

      orderInfo: {},//订单信息对象


      chCityOptions: [],//文件下单的中国城市信息集合
      EnCityOptions: [], //文件下单的海外城市信息集合
      loading: false, //是否显示加载中

      ////-------------------保险信息---------------------/////
      OrderInsuranceInfos: {
        IsBuy: false,//是否购买保险
        BenefitType: 1,//受益人类型 1：公司，2：个人
        BuyAmount: null, Beneficiary: '',
        IsNeedVoucher: false, //是否需要保险凭证
      },
      goodsSumVal: null,//保险信息申报价值

      ////-------------------附加费用项---------------------/////
      OrderExtraFeeInfos: [], //传给后台的附加费 预估费用项

      OrderFeeInfo1: [],//必收附加费
      OrderFeeInfo2: [],//可能产生的附加费

      //预估费用：
      custFee: 0,//一般贸易报关费 放弃这个 之前默认35
      pickupFee: null,//提货-取件费
      thInfo: {},//传给后台的取件信息
      freightFee: null,//运费

      //编辑页面上弹框
      showModal: false,//遮罩层

      ShipperBox: false,//发件人选择弹框
      ShipperBoxList: [],//发件人弹框列表

      ConsigneeBox: false, //收件人弹框列表
      ConsigneeBoxList: [],

      proInfoBox: false, //产品信息弹框
      porductList: [], //产品信息弹框列表

      searchInput: '',
      chkAll: false,
      isDisabled: false,
      isTrue: false, //是否勾选了产品，才点击确定

      //我的发票，选择发票弹框
      myInivoceBox: false,
      searchInvoiceInput: '',
      invoiceBoxList: [],//弹框列表

      templateInfo: [],
      invTemplate: '', invTemplateUrl: '', //模板名称和路径值

      InvLoading: false,
      InvNoData: false,
      InvoData: true,

      invoInputBox: false,
      InvoiceTitle: '',//我的发票弹框标题
      isMakeInvoice: false, //判断是否是制作新发票，制作新发票，调用保存新发票接口，否则不调用
      shipDisabled: false, //是否禁止修改发件人信息中的公司

      //从编辑页面拿收发件人信息和发票详情信息传值到发票组件中
      ordNo: '',//订单号赋值到我的发票组件中
      ConsigDefaultMsg: {},  //传值到我的发票组件中   
      ConsignorMsg: {},//发件人信息
      pordDefultMsg: [],    //产品信息取默认值，赋值到发票组件中
      myInvoiceInfo: {},  //发票编辑信息传值到我的发票组件中

      //验证信息
      expShow: 0, //验证信息
      isRedInsur: false, //保险信息，投保金额大于申报价值，则提示信息
      isOrdBtnGray: false, //是否显示订单提交中
      CurEORI: '', //ERIO显示

      IsBlacklistUserID: false, //收件人是否是黑名单

      //防疫物资产品信息
      proDibed: false, //防疫物资下单禁用产品信息，不给编辑
      Surcharge: 0,
      currentPageMy: 1,
      pageSizeMy: 20,
      totalMy: 0,
      AuthenticatedType:0,
    };
  },

  created() {
    this.getExpEditInfo(); //获取订单详情接口
    console.log("this.OrderExtraFeeInfos", this.OrderExtraFeeInfos);
  },
  mounted() {
    this.getValidation(); //验证调取

    //货物运输方式，黑名单接口使用  
    bus.$on('expBaseModeCode', (res) => {
      this.transportationID = res
    })
    //防疫物资专题页面下单，产品信息要自动赋值
    if (this.$route.query.cargoCode) {
      console.log('this.$route.query.cargoCode ' + JSON.stringify(this.$route.query.cargoCode));
      this.proDibed = true
      this.getProList()
    } else {
      this.proDibed = false
    }

  },
  watch: {

  },
  computed: { //计算属性

    //是否显示EORI输入框，当运输方式为FEDEX，并且国家为德国、法国、西班牙时显示;当运输方式为DHL，并且国家为英国、意大利、保加利亚时显示
    //货物信息显示
    //货物种类：判断是都有配套电池，有的话，显示配套电池下拉框；109--配套电池ID
    isShowMatBat() {
      //console.log('this.EditOrderReqEn.CargoIDs ' + JSON.stringify(this.EditOrderReqEn.CargoIDs))
      let isOK = true
      if (this.EditOrderReqEn.CargoIDs.indexOf('109') == -1) {
        isOK = false
      }
      return isOK
    },
    //货物种类：判断是都有内置电池，有的话，显示内置电池下拉框;108--内置电池ID
    isShowInsideBat() {
      let isOK = true
      if (this.EditOrderReqEn.CargoIDs.indexOf('108') == -1) {
        isOK = false
      }
      return isOK
    },
    //是否显示货物信息  103--纯电池ID;108--内置电池ID;109--配套电池ID
    isShowCargoInfo() {
      let FEDEX = 'FEDEX';//运输方式FEDEX
      let UPS = 'UPS';//运输方式UPS
      let isOK = true
      //货物信息大块显示，上述5种其中有任何一个就显示
      if (this.EditOrderReqEn.CargoIDs.indexOf('103') == -1 &&
        this.EditOrderReqEn.CargoIDs.indexOf('108') == -1 &&
        this.EditOrderReqEn.CargoIDs.indexOf('109') == -1 &&
        FEDEX != this.EditOrderReqEn.BaseModeCode &&
        UPS != this.EditOrderReqEn.BaseModeCode &&
        'ARAMEX' != this.EditOrderReqEn.BaseModeCode &&
        'TNT' != this.EditOrderReqEn.BaseModeCode
      ) {
        isOK = false
      }
      return isOK
    },

    //保险费用计算
    insuranceCost() {
      return this.OrderInsuranceInfos.BuyAmount * 0.0018
    },
    //预估费用
    EstimateCost() {
      let sum = 0
      let sum01 = 0 ////必收附加费+勾选的附加费总和
      let sum02 = 0 //运费+提货费+一般贸易报关费+bank charge+保险费+



      //必收附加费+勾选的附加费总和
      if (this.OrderExtraFeeInfos) {
        this.OrderExtraFeeInfos.forEach(item => {
          sum01 += this.waysCostNum(item)
        })
      }
      //this.custFee  一般贸易报关费 文件的时候是没有的
      if (this.EditOrderReqEn.PackageType == 1) {
        if (this.OrderInsuranceInfos.IsBuy == true) {
          sum02 = this.freightFee + this.pickupFee + this.custFee + this.bankCharFee + this.insuranceCost
        } else if (this.OrderInsuranceInfos.IsBuy == false) {
          sum02 = this.freightFee + this.pickupFee + this.bankCharFee + this.custFee
        }
      } else if (this.EditOrderReqEn.PackageType == 2) {
        sum02 = this.freightFee + this.pickupFee + this.bankCharFee
      }
      sum = sum01 + sum02
      return sum
    },

    //bank Charge: 英文版都要固定收取Bank Charge，显示在预估费用明细中，固定为上述预估费用的5%，最高收取50USD/票。
    bankCharFee() {
      let sum = 0
      let sum01 = 0
      let sum02 = 0
      this.OrderExtraFeeInfos.forEach(item => {
        sum01 += this.waysCostNum(item)
      })
      if (this.EditOrderReqEn.PackageType == 1) {
        if (this.OrderInsuranceInfos.IsBuy == true) {
          sum02 = (sum01 + this.freightFee + this.pickupFee + this.custFee + this.insuranceCost) * 0.05
        } else if (this.OrderInsuranceInfos.IsBuy == false) {
          sum02 = (sum01 + this.freightFee + this.pickupFee + this.custFee) * 0.05
        }
      } else if (this.EditOrderReqEn.PackageType == 2) {
        sum02 = (sum01 + this.freightFee + this.pickupFee) * 0.05
      }
      if (sum02 >= 50) {
        sum = 50
      } else {
        sum = sum02
      }
      return sum
    },

  },
  methods: {

    //防疫物资产品信息数据 
    getProList() {//读取产品json
      fetch('/static/data/fyProductData.json').then((res) => {
        //赋值
        // console.log('sd '+ JSON.stringify(this.$route.query.cargoCode));
        res.forEach(e => {


          if (e.AttrVal_Code == this.$route.query.cargoCode) {
            this.OrderProductInfos = [e.productInfos]
          }
        })
      })
    },

    //ERIO 的文本显示
    getERIO() {
      // console.log(this.EditOrderReqEn.ModeCode)
      let EORIInfo =
      //title 显示文本， 
      // status 如果存在，说明私人地址显示。status为1 ，则说明显示且勾选后左边输入框置灰, status为2 ，则说明显示且不勾选后左边输入框置灰
      {
        "FEDEX-HK": [
          { "name": "德国", "title": "EORI" },
          { "name": "法国", "title": "EORI" },
          { "name": "西班牙", "title": "EORI" },
          // {"name":"意大利","title":"ID number/Tax ID"},
          { "name": "墨西哥", "title": "VAT" },
          { "name": "智利", "title": "VAT" },
          { "name": "哥伦比亚", "title": "VAT" },
          { "name": "秘鲁", "title": "VAT" },
          { "name": "多米尼加共和国", "title": "VAT" },
          { "name": "阿根廷", "title": "VAT" },
          { "name": "厄瓜多尔", "title": "VAT" }
        ],
        "DHL-HK": [
          { "name": "英国", "title": "EORI" },
          { "name": "意大利", "title": "EORI" },
          { "name": "保加利亚", "title": "EORI" }
        ]
      }
      // console.log(this.EditOrderReqEn.ModeCode)
      if (EORIInfo[this.EditOrderReqEn.ModeCode] && this.EditOrderReqEn.PackageType == 1) {
        this.CurEORI = EORIInfo[this.EditOrderReqEn.ModeCode].filter(item => {
          return item.name == this.EditOrderReqEn.DestCountryName
          // return item.name  == "墨西哥" //用来测试数据，请注释/上方代码

        });
        this.CurEORI = this.CurEORI[0]
      } else {
        this.CurEORI = ''
      }
    },

    //验证调取
    getValidation() {
      $('#expEditValidation').validationEngine();
    },
    getCheckForm() {
      return $("#expEditValidation").validationEngine('validate');
      //$('#form1').validationEngine('validate')
    },

    //获取订单详情接口数据接口
    getExpEditInfo() {
      let that = this;
      // that.api.url = this.$api03 + "/api/TradeCustomer/ExpNewOrder/GetDetailEn/" + that.$route.query.ord;
      that.api.url = this.$api04 + "/Express/api/ExpNewOrder/GetDetailEn/" + that.$route.query.ord;
      fetch(that.api.url).then(function (res) {
        that.orderInfo = res.Results.order
        that.AuthenticatedType = res.Results.AuthenticatedType
        that.EditOrderReqEn.EORI = res.Results.order.EORI
        that.EditOrderReqEn.WaybillNO = res.Results.order.Id
        that.EditOrderReqEn.ChannelKey = res.Results.order.ChannelKey
        that.EditOrderReqEn.StartCityKey = res.Results.order.StartCityKey
        that.EditOrderReqEn.StartCityName = res.Results.order.StartCityName
        that.EditOrderReqEn.StartCityNameEn = res.Results.order.StartCityNameEn
        that.EditOrderReqEn.DestCountrKey = res.Results.order.DestCountryKey
        that.EditOrderReqEn.DestCountryName = res.Results.order.DestCountryName
        that.EditOrderReqEn.DestCountryNameEn = res.Results.order.DestCountryNameEn

        that.EditOrderReqEn.BaseModeCode = res.Results.order.BaseModeCode  //运输方式大类

        bus.$emit('expBaseModeCode', res.Results.order.BaseModeCode) //传运输方式到发票模板中，调用黑名单接口使用

        that.EditOrderReqEn.PackageType = res.Results.order.PackageType
        that.EditOrderReqEn.RefNO = res.Results.order.RefNO

        that.EditOrderReqEn.CargoIDs = res.Results.order.CargoIDs
        that.EditOrderReqEn.CargoDescs = res.Results.order.CargoDescsEn

        if (res.Results.thInfo) {
          that.EditOrderReqEn.THworkDay = res.Results.thInfo.WorkDaysStr  //取件时效
        }

        //电池资料选项
        if (res.Results.order.InsideBattery != 0) {
          that.EditOrderReqEn.InsideBattery = res.Results.order.InsideBattery
        } else {
          that.EditOrderReqEn.InsideBattery = 0
        }

        if (res.Results.order.MatingBattery != 0) {
          that.EditOrderReqEn.MatingBattery = res.Results.order.MatingBattery
        } else {
          that.EditOrderReqEn.MatingBattery = 0
        }

        that.EditOrderReqEn.BatteryCountType = res.Results.order.BatteryCountType
        that.EditOrderReqEn.BatterySelectInfo = res.Results.order.BatterySelectInfo

        that.EditOrderReqEn.OrderCount = res.Results.order.OrderCount
        that.EditOrderReqEn.OrderWeight = res.Results.order.OrderWeight
        that.EditOrderReqEn.OrderVolume = res.Results.order.OrderVolume
        that.EditOrderReqEn.InvoiceType = res.Results.order.InvoiceType //我的发票类型

        that.EditOrderReqEn.OrderChargeWeight = res.Results.order.OrderChargeWeight //下单计费重

        //用订单详情接口返回的我的发票类型判断是否有我的发票信息
        if (res.Results.order.InvoiceType == 4) {
          that.InvoiceInfoPage.invTemplateChk = res.Results.Contact.ConsignorCompany//选择我的发票名称
          //赋值到我的发票组件中
          that.ordNo = res.Results.order.Id
          that.shipDisabled = true


          //产品信息
          let goodsInfoArr = []
          let sumVal = 0
          res.Results.productList.forEach(info => {
            //给货物保险投保金额赋值 goodsSumVal
            sumVal += info.Quanlity * info.Price
            //给发票赋值
            let objGoods = {
              Commodity: info.EnglishName,
              Material: info.Material,
              Use: info.Purpose,
              HSCode: info.HSCode,
              Qty: info.Quanlity,
              UnitPrice: info.Price,
            }
            goodsInfoArr.push(objGoods)
          })
          that.goodsSumVal = sumVal

          that.OrderInsuranceInfos.BuyAmount = that.goodsSumVal //给货物保险投保金额赋值

          let initData = {
            InvoiceNo: res.Results.Invoice.InvoiceNO,//我的发票
            DateofExportation: new Date(res.Results.Invoice.DateofExportation),
            originalCountry: res.Results.Invoice.CountryofOrigin,//原产地
            WaybillNO: res.Results.Invoice.WaybillNO,
            //发件人信息
            shipperCompany: res.Results.Contact.ConsignorCompany,
            shipperContact: res.Results.Contact.Consignor,
            shipperMail: res.Results.Contact.ConsignorEmail,
            shipperTEL: res.Results.Contact.ConsignorTel,
            shipperAddr: res.Results.Contact.ConsignorAddress,
            shipperProv: res.Results.Contact.ConsignorProvince,
            shipperProvKey: res.Results.Contact.ConsignorProvinceKey,
            shipperCity: res.Results.Contact.ConsignorCity,
            shipperCity_Key: res.Results.Contact.ConsignorCityKey,
            shipperCountry: res.Results.Contact.ConsignorCountry,
            //shipperCountry_Key:'',
            shipperZipCode: res.Results.Contact.ConsignorZipcode,

            //收件人信息
            consigCompany: res.Results.Contact.ConsigneeCompany,
            consigContact: res.Results.Contact.Consignee,
            consigTEL: res.Results.Contact.ConsigneeTel,
            consigCountry: res.Results.Contact.ConsigneeCountry,
            Country_Key: res.Results.Contact.ConsigneeCountryKey,
            consigZipCode: res.Results.Contact.ConsigneeTel,
            consigAddr: res.Results.Contact.ConsigneeAddress,
            consigCity: res.Results.Contact.ConsigneeCity,
            //consigIsDefault:false,
            // consigID:res.Results.Contact.ConsigneeCompany,//收件人ID
            //产品信息
            goodsInfoList: goodsInfoArr
          }

          that.invoiceBackup = initData
          that.InvoiceInfo = initData

        } else {
          //获取我的发票详情值
        }
        that.EditOrderReqEn.CusInvoiceInfoID = res.Results.order.CusInvoiceInfoID  //我的发票ID
        // that.EditOrderReqEn.ConsigneeID=res.Results.order.CusInvoiceInfoID  //收件人ID

        that.EditOrderReqEn.Remark = res.Results.order.Remark  //备注

        ////-------------------文件列表---------------------////
        that.OrderUploadFilesInfos = res.Results.fileList

        ////--------------------产品库信息--------------------////
        if (res.Results.productList.length > 0) {
          that.OrderProductInfos = res.Results.productList
        } else {

          if (!that.$route.query.cargoCode) {
            that.getCargoDataAPI(1); //取产品库中设为默认的信息
          }
        }

        ////--------------------包裹收发件人信息--------------------////
        if (res.Results.order.PackageType == 1) {
          //收件人信息 目的国家取值当前渠道的数据
          that.OrderContactInfos.ConsigneeCountry = res.Results.order.DestCountryNameEn
          that.OrderContactInfos.ConsigneeCountryKey = res.Results.order.DestCountryKey

          if (res.Results.Contact) {
            //发件人信息
            that.OrderContactInfos.Consignor = res.Results.Contact.Consignor
            that.OrderContactInfos.ConsignorCompany = res.Results.Contact.ConsignorCompany
            that.OrderContactInfos.ConsignorTel = res.Results.Contact.ConsignorTel
            that.OrderContactInfos.ConsignorZipcode = res.Results.Contact.ConsignorZipcode
            that.OrderContactInfos.ConsignorAddress = res.Results.Contact.ConsignorAddress

            that.OrderContactInfos.ConsignorProvinceKey = res.Results.Contact.ConsignorProvinceKey
            that.OrderContactInfos.ConsignorProvince = res.Results.Contact.ConsignorProvince
            that.OrderContactInfos.ConsignorCityKey = res.Results.Contact.ConsignorCityKey
            that.OrderContactInfos.ConsignorCity = res.Results.Contact.ConsignorCity

            //收件人信息
            that.OrderContactInfos.Consignee = res.Results.Contact.Consignee
            that.OrderContactInfos.ConsigneeCompany = res.Results.Contact.ConsigneeCompany
            that.OrderContactInfos.ConsigneeTel = res.Results.Contact.ConsigneeTel
            that.OrderContactInfos.ConsigneeZipcode = res.Results.Contact.ConsigneeZipcode
            that.OrderContactInfos.ConsigneeEmail = res.Results.Contact.ConsigneeEmail
            that.OrderContactInfos.ConsigneeAddress = res.Results.Contact.ConsigneeAddress
            // that.OrderContactInfos.ConsigneeCountry=res.Results.Contact.ConsigneeCountry
            // that.OrderContactInfos.ConsigneeCountryKey=res.Results.Contact.ConsigneeCountryKey
            that.OrderContactInfos.ConsigneeCity = res.Results.Contact.ConsigneeCity

          } else {
            that.getConsigneeDataAPI();//收件人默认数据接口
          }

          //发件人shipper信息
          if (res.Results.Shipper) {
            that.Shipper.ContactName = res.Results.Shipper.ContactName
            that.Shipper.Company = res.Results.Shipper.Company
            that.Shipper.ContactTel = res.Results.Shipper.ContactTel
            that.Shipper.ZipCode = res.Results.Shipper.ZipCode
            that.Shipper.Email = res.Results.Shipper.Email
            that.Shipper.Country = res.Results.Shipper.Country
            that.Shipper.CountryKey = res.Results.Shipper.CountryKey
            that.Shipper.Province = res.Results.Shipper.Province
            that.Shipper.ProvinceKey = res.Results.Shipper.ProvinceKey
            that.Shipper.City = res.Results.Shipper.City
            that.Shipper.CityKey = res.Results.Shipper.CityKey
            that.Shipper.Address = res.Results.Shipper.Address
          } else {
            // that.getSendDataAPI(); //发件人默认数据接口
          }
        } else if (res.Results.order.PackageType == 2) {
          ////--------------------文件收发件人信息--------------------////
          //收件人信息国家和国家key
          that.OrderDocInfos.ConsigneeCountry = res.Results.order.DestCountryNameEn
          that.OrderDocInfos.ConsigneeCountryKey = res.Results.order.DestCountryKey
          if (res.Results.Contact) {
            //发件人信息
            that.OrderDocInfos.Consignor = res.Results.Contact.Consignor
            that.OrderDocInfos.ConsignorCompany = res.Results.Contact.ConsignorCompany
            that.OrderDocInfos.ConsignorTel = res.Results.Contact.ConsignorTel
            that.OrderDocInfos.ConsignorZipcode = res.Results.Contact.ConsignorZipcode
            that.OrderDocInfos.ConsignorAddress = res.Results.Contact.ConsignorAddress

            that.OrderDocInfos.ConsignorProvinceKey = res.Results.Contact.ConsignorProvinceKey
            that.OrderDocInfos.ConsignorProvince = res.Results.Contact.ConsignorProvince
            that.OrderDocInfos.ConsignorCity = res.Results.Contact.ConsignorCity
            that.OrderDocInfos.ConsignorCityKey = res.Results.Contact.ConsignorCityKey

            that.getChinaCityInfo(that.OrderDocInfos.ConsignorCity);//调用中国城市数据接口

            // that.getCHCityAPI(that.sendInfo.ProvKey);

            //收件人信息
            that.OrderDocInfos.Consignee = res.Results.Contact.Consignee
            that.OrderDocInfos.ConsigneeCompany = res.Results.Contact.ConsigneeCompany
            that.OrderDocInfos.ConsigneeTel = res.Results.Contact.ConsigneeTel
            that.OrderDocInfos.ConsigneeZipcode = res.Results.Contact.ConsigneeZipcode
            that.OrderDocInfos.ConsigneeEmail = res.Results.Contact.ConsigneeEmail
            that.OrderDocInfos.ConsigneeAddress = res.Results.Contact.ConsigneeAddress
            that.OrderDocInfos.ConsigneeCity = res.Results.Contact.ConsigneeCity
          } else {
            //取收发件人信息默认值
            that.getSendDataAPI();//发件人默认数据接口
            that.getConsigneeDataAPI();//收件人默认数据接口
          }
        }

        ////--------------------保险信息--------------------////
        if (res.Results.Insurance) {
          if (res.Results.Insurance.BenefitType == 1) {
            that.OrderInsuranceInfos.BenefitType = res.Results.Insurance.BenefitType //受益人类型
            that.OrderInsuranceInfos.BuyAmount = res.Results.Insurance.BuyAmount //购买保险金额
            that.OrderInsuranceInfos.Beneficiary = res.Results.Insurance.Beneficiary //受益公司
            that.OrderInsuranceInfos.IsBuy = res.Results.Insurance.IsBuy //是否购买保险
          }
        }

        //取件费 pickupFee
        if (res.Results.isHavePickOrder == true && res.Results.thInfo) {
          that.pickupFee = res.Results.thInfo.PickupFee
          that.thInfo = res.Results.thInfo
        }

        //接口调用
        that.getExpChannelInfo(res.Results.order.ChannelKey, res.Results.order.DestCountryKey);//渠道运输方式，参考时效，包含货物，风险提示信息，是否有电池资料信息接口
        that.getCostInfoAPI(res.Results);//可能产生的附加费接口数据、还有必收附加费，匹配到的附加费接口数据
        that.getExpFeeInfo(res.Results); //运费计算
        //that.getShipAddr(res.Results.order); //仓库接口
        that.getInvoiceTemplate(res.Results.order.ChannelKey, res.Results.order.DestCountryKey);//获取发票类型数据

        that.getInvTemp(res.Results.order.ChannelKey, res.Results.order.DestCountryKey);//获取发票模板数据


        //   

      })
    },

    //产品信息库默认地址显示到产品信息库中 val 判断是哪个地方调用接口
    async getCargoDataAPI(val) {
      let that = this
      that.api.param = {}
      // that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Get';
      that.api.url = that.$api04 + "/Basics/api/BasProduct/Get";
      await fetch(that.api.url, that.api.param).then(function (res) {
        if (val == 1) {
          if (res.Results.length > 0) {
            res.Results.forEach(item => {
              that.$set(item, 'Id', item.ID);
              if (item.IsSelected == true) {
                for (var i = that.OrderProductInfos.length - 1; i >= 0; i--) {
                  let e = that.OrderProductInfos[i]
                  if (!e.EnglishName && !e.Material && !e.Purpose && !e.CustomsCode) {
                    that.OrderProductInfos.splice(i, 1)
                  }
                }
                that.OrderProductInfos.push(item)
              }
            })
          }
        } else if (val == 2) {
          that.pordDefultMsg = []
          if (res.Results.length > 0) {
            res.Results.forEach(item => {
              if (item.IsSelected == true) {
                that.pordDefultMsg.push(item)
              }
            })
          }
        }
        //console.log('pordDefultMsg   ' + JSON.stringify( that.pordDefultMsg))     
      })
    },

    //发件人信息地址，没有编辑提交订单的时候，有默认地址信息，把默认地址信息赋值到发件人信息里面
    getSendDataAPI() {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addresser/List';
      that.api.url = that.$api04 + '/Basics/api/Addresser/List';
      post(that.api.url).then(function (res) {
        if (res.Results) {
          res.Results.forEach(e => {
            if (e.Address_IsDefault == true) {
              //发件人信息 Shipper
              that.OrderDocInfos.Consignor = e.Address_Name
              that.OrderDocInfos.ConsignorCompany = e.company
              that.OrderDocInfos.ConsignorTel = e.Address_Tel
              that.OrderDocInfos.ConsignorZipcode = e.Address_ZIPCode
              that.OrderDocInfos.ConsignorEmail = e.Address_Mail
              that.OrderDocInfos.ConsignorProvince = e.SendProvinceEn
              that.OrderDocInfos.ConsignorProvinceKey = e.Province_Key
              that.OrderDocInfos.ConsignorCity = e.SendCitynameEn
              that.OrderDocInfos.ConsignorCityKey = e.City_Key
              that.OrderDocInfos.ConsignorAddress = e.Address_Street

              that.getChinaCityInfo(that.OrderDocInfos.ConsignorCity);//调用中国城市数据接口
            }
          })
        }
      })
    },
    //收件人信息地址，没有编辑提交订单的时候，有默认地址信息，把默认地址信息赋值到收件人信息里面
    getConsigneeDataAPI() {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addressee/List';
      that.api.url = that.$api04 + "/Basics/api/Addressee/List";
      post(that.api.url, {
        Page: 1,
        Size: 99999
      }).then(function (res) {
        if (res.Results) {
          res.Results.forEach(e => {
            if (e.Address_IsDefault == true) {
              //包裹下单的收件人信息
              if (that.OrderContactInfos.ConsigneeCountryKey == e.Country_Key) { //默认值的国家和下单的目的国家一致才有默认值，否则没有默认值
                that.OrderContactInfos.Consignee = e.Address_Name
                that.OrderContactInfos.ConsigneeCompany = e.company
                that.OrderContactInfos.ConsigneeTel = e.Address_Tel
                that.OrderContactInfos.ConsigneeZipcode = e.Address_ZIPCode
                that.OrderContactInfos.ConsigneeEmail = e.Address_Mail
                that.OrderContactInfos.ConsigneeAddress = e.Address_Street

                that.OrderContactInfos.ConsigneeCity = e.Address_City
                that.OrderContactInfos.ConsigneeID = e.Address_ID || 0 //收件人Id

                that.OrderContactInfos.ConsigneeCountry = e.RecCountryNameEn
                that.OrderContactInfos.ConsigneeCountryKey = e.Country_Key
              }


              //文件下单的收件人信息
              if (that.OrderDocInfos.ConsigneeCountryKey == e.Country_Key) { //默认值的国家和下单的目的国家一致才有默认值，否则没有默认值
                that.OrderDocInfos.Consignee = e.Address_Name
                that.OrderDocInfos.ConsigneeCompany = e.company
                that.OrderDocInfos.ConsigneeTel = e.Address_Tel
                that.OrderDocInfos.ConsigneeZipcode = e.Address_ZIPCode
                that.OrderDocInfos.ConsigneeEmail = e.Address_Mail
                that.OrderDocInfos.ConsigneeAddress = e.Address_Street
                that.OrderDocInfos.ConsigneeCity = e.Address_City
                that.OrderDocInfos.ConsigneeID = e.Address_ID || 0//收件人Id
              }
            }
          })
        }
      })
    },

    //渠道运输方式，参考时效，包含货物，风险提示信息，是否有电池资料信息接口
    getExpChannelInfo(chaKey, desKey, cargoId) {
      let that = this;
      that.api.param = {
        channelKey: chaKey,
        countryKey: desKey,
      }
      //that.api.url = this.$api01 + "/api/InfoCustomer/ExpChannel/GetExpChannel";
      that.api.url = that.$api04 + "/Express/api/ExpChannel/GetExpChannel";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          //console.log('res  '  + JSON.stringify(res.Results))
          //头部信息
          that.EditOrderReqEn.BatteryRequired = res.Results.BatteryRequired //是否有电池资料信息
          that.EditOrderReqEn.ModeCode = res.Results.ModeCode  //运输方式
          // that.cargoInfo.batDocTips=res.Results.BatteryNotice  //有无电池资料

          //参考时效 + 取件时效
          let arr = []
          if (res.Results.WorkDaysStr && res.Results.WorkDaysStr.indexOf('-') != -1) {
            arr = res.Results.WorkDaysStr.split('-')
            let minWorkDays = parseFloat(arr[0]) + Number(that.EditOrderReqEn.THworkDay)
            let maxWorkDay = parseFloat(arr[1]) + Number(that.EditOrderReqEn.THworkDay)
            that.EditOrderReqEn.workDay = minWorkDays + '-' + maxWorkDay
          } else {
            that.EditOrderReqEn.workDay = Number(res.Results.WorkDaysStr) + Number(that.EditOrderReqEn.THworkDay) //取件参考时效
          }
          that.getERIO()
        }
      })
    },

    //货物种类，判断是否有FEDEX、UPS、ARAMEX、TNT,有则显示产品信息模块
    isShowGoodsInfo() {
      let isOK = false
      if ('FEDEX' == this.EditOrderReqEn.BaseModeCode ||
        'UPS' == this.EditOrderReqEn.BaseModeCode ||
        'ARAMEX' == this.EditOrderReqEn.BaseModeCode ||
        'TNT' == this.EditOrderReqEn.BaseModeCode
      ) {
        let isAli = this.isAli();
        if(isAli){
          isOK = false;
        }else{
          isOK = true
        }
      }
      //console.log('isOK11111    ' + isOK)
      return isOK
      //return true
    },
    //判断是否是阿里账户，如果是阿里账户则不显示产品信息和收发件人信息
    isAli(){
      let isOk = false
      if(this.AuthenticatedType == 4){
        isOk = true;
      }
      //console.log('isOK22222    ' + isOk)
      return isOk;
    },
    ////--------------------------货物信息----------------------------////
    //点击产品信息按钮
    clkProInfo() {
      this.showModal = true;
      this.proInfoBox = true;
      this.chkAll = false;
      this.getPorductListAPI();
    },
    //产品信息弹框列表接口
    getPorductListAPI() { //产品信息库接口数据
      let that = this
      that.api.param = {}
      // that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Get';
      that.api.url = that.$api04 + "/Basics/api/BasProduct/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          if (res.Results.length <= 0) {
            that.isDisabled = true //全选禁掉
          } else {
            res.Results.forEach(item => {
              that.$set(item, 'Id', item.ID);
            })
            that.porductList = res.Results
            that.isDisabled = false //全选开启
            that.porductList.forEach((item) => {
              Vue.set(item, 'checkStatus', false)
            })
          }
        }
      })
    },
    //全选
    chkAllEvent(val) {
      var that = this;
      that.porductList.forEach(function (chk) {
        chk.checkStatus = that.chkAll
      })
      if (that.chkAll) {
        that.isTrue = true
      } else {
        that.isTrue = false
      }
    },
    //单选
    chkStatusEvent() {
      let that = this
      var select = that.porductList.filter(function (chk, k) {
        return chk.checkStatus == true
      })
      select.length == that.porductList.length ? that.chkAll = true : that.chkAll = false
      if (select.length > 0) {
        that.isTrue = true
      } else {
        that.isTrue = false
      }
    },
    //确定按钮
    proConfirmBtn() {
      let that = this
      if (that.isTrue == true) {
        for (var i = this.OrderProductInfos.length - 1; i >= 0; i--) {
          let e = this.OrderProductInfos[i]
          if (!e.EnglishName && !e.Material && !e.Purpose && !e.CustomsCode && !e.Quanlity && !e.Price) {
            this.OrderProductInfos.splice(i, 1)
          }
        }
        this.porductList.forEach(function (e) {
          if (e.checkStatus == true) {
            let arrInfo = {
              EnglishName: e.EnglishName,
              Material: e.Material,
              Purpose: e.Purpose,
              CustomsCode: e.CustomsCode,
            }
            that.OrderProductInfos.push(arrInfo)
          }
        })
      }

      this.showModal = false;
      this.proInfoBox = false;
    },
    //产品信息查询接口
    clkSearchBtn(val) {
      this.searchPorduct(val)
    },
    searchPorduct(val) {
      let that = this
      that.api.param = {
        EnglishName: val
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Query';
      post(that.api.url, that.api.param).then(function (res) {
        that.porductList = res.Results
      })
    },


    //-------------上传电池资料-------------------------//
    handleBatExceed(files, fileList) { //限制最大个数的
      this.$message.warning('Upload up to 20 attachments！')
    },
    //上传限制
    beforeBatUpload(file, fileList) {  //上传文件之前做验证
      const extension = ' .jpg, .jpeg, .gif, .png, .bmp, .pic, .doc, .docx, .rar, .xls, .xlsx, .pdf, .zip, .7z, '
      var fileName = file.name;
      var ext = fileName.substring(fileName.lastIndexOf('.'), fileName.length) + ", ";

      if (extension.indexOf(ext) == -1) {
        this.$confirm('The imported file can only be in ' + extension + 'format!', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      const isLt4M = file.size / 1024 / 1024 < 10
      const isLtZeroM = file.size / 1024 / 1024 > 0
      if (!isLt4M) {
        this.$confirm('Upload file size is over 10M!', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      if (!isLtZeroM) {
        this.$confirm('The file size is 0kb, please re-upload!', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      //上传文件名不能超多50个字符
      if (fileName.length > 100) {
        this.$confirm('The file name is over 100 characters,please re-upload！', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      return true
    },
    //电池资料上传成功
    batUpSuccess(file, fileList) { //文件上传成功方法
      if (file.Results.UploadPath) {
        this.OrderUploadFilesInfos.push({ AttachType :4,FIlePath: file.Results.UploadPath, OriginaFilelName: this.$route.query.ord + '_' + fileList.name, BuildFileName: this.$route.query.ord + '_' + fileList.name })
      }
    },
    //附件上传成功
    batAttSuccess(file, fileList) {
      if (file.Results.UploadPath) {
        var name = fileList.name.indexOf(this.$route.query.ord) > -1 ? fileList.name : this.$route.query.ord + '_' + fileList.name;
        this.OrderUploadFilesInfos = [
          {
            FIlePath: file.Results.UploadPath,
            OriginaFilelName: fileList.name,
            BuildFileName: name,
            AttachType :1,
          }
        ]
      }
      this.expShow = 0
    },

    //附件列表点击删除，删除其中一个
    removeTodo(item, index) {
      if (!item.Id) {
        this.delFileList(item.FIlePath)
      } else {
      }
      this.OrderUploadFilesInfos.splice(index, 1);
    },
    //附件删除接口
    delFileList(val) {
      //this.OrderUploadFilesInfos.splice(index, 1);
      let that = this
      that.api.param = {
        UploadPath: val,
      }
      // that.api.url = that.$api03 + '/api/TradeCustomer/FileUpload/DeleteFile'
      that.api.url = that.$api04 + '/File/api/FileHandle/DeleteFile'
      post(that.api.url, that.api.param).then(function (res) {
        //that.OrderUploadFilesInfos=[]
      })
    },
    //-----------------------------------电池货物信息-----------------------------------------------//
    //电池种类说明
    clkBattery() {
      this.$refs.batteryRef.clkOpenBox()
    },

    //判断是否显示【此票货含电池个数】行
    //入参batReqStr：电池货要求字符串，如 [{"BatteryType":1,"RequiredInfo":[2,3],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[1,2,3,4,5],"OtherInfo":"256633"},{"BatteryType":3,"RequiredInfo":[0],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[0],"OtherInfo":null}]
    isShowBatteryCount(batReqStr) {
      //console.log('batReqStr222  '  +  batReqStr)
      if (!batReqStr) {
        return false;
      }
      let builtIn = '108'; //内置电池ID
      //如果订单货物没有内置电池，不显示
      if (this.EditOrderReqEn.CargoIDs.indexOf(builtIn) == -1) {
        return false;
      }

      //判断结果
      let isShow = false;

      //电池货要求
      let batReq = JSON.parse(batReqStr);
      //遍历电池货要求
      batReq.forEach(e => {
        //是否设置了[内置电池]的[电池个数超过2个需提供上述电池资料]
        if (e.BatteryType == 2 && $.inArray(5, e.RequiredInfo) >= 0) {
          isShow = true;
          return false; //结束循环
        }
      });
      return isShow;
    },

    //判断是否显示【有无电池资料】行
    //batReqStr：电池货要求字符串，如 [{"BatteryType":1,"RequiredInfo":[2,3],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[1,2,3,4,5],"OtherInfo":"256633"},{"BatteryType":3,"RequiredInfo":[0],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[0],"OtherInfo":null}]
    isShowBatteryInfo(batReqStr) {
      if (!batReqStr) {
        return false;
      }

      let pure = '103'; //纯电池ID
      let builtIn = '108'; //内置电池ID
      let supporting = '109'; //配套电池ID

      //电池货要求
      let batReq = JSON.parse(batReqStr);

      //如果订单货物有纯电池，且电池货要求里纯电池需提供资料，显示
      if (this.isNeedBatDoc(pure, 1, batReq)) {
        return true;
      }

      //如果页面上选了配套电池（锂电池）相关下拉项，且电池货要求里配套电池（锂电池）需提供资料，显示
      if ((this.EditOrderReqEn.MatingBattery == 18 || this.EditOrderReqEn.MatingBattery == 19) &&
        this.isNeedBatDoc(supporting, 3, batReq)) {
        return true;
      }

      //如果页面上选了配套电池（干电池）相关下拉项，且电池货要求里配套电池（干电池）需提供资料，显示
      if (this.EditOrderReqEn.MatingBattery == 17 && this.isNeedBatDoc(supporting, 4, batReq)) {
        return true;
      }

      //如果页面上选了内置电池的下拉项，且电池货要求里内置电池需提供资料
      if (this.EditOrderReqEn.InsideBattery && this.isNeedBatDoc(builtIn, 2, batReq)) {
        //如果不需要判断电池个数，显示
        if (this.isShowBatteryCount(batReqStr) == false) {
          return true;
        }

        //如果需要判断电池个数，且电池个数选择了[>2个]，显示
        if (this.EditOrderReqEn.BatteryCountType == 2) {
          return true;
        }
      }

      return false;
    },

    //获取[有无电池资料]括号内的电池类型文本
    //batReqStr：电池货要求字符串，如 [{"BatteryType":1,"RequiredInfo":[2,3],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[1,2,3,4,5],"OtherInfo":"256633"},{"BatteryType":3,"RequiredInfo":[0],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[0],"OtherInfo":null}]
    getBatteryText(batReqStr) {
      if (!batReqStr) {
        return "";
      }

      //电池类型集合
      let lstBatteryText = [];

      let pure = '103'; //纯电池ID

      //电池货要求
      let batReq = JSON.parse(batReqStr);

      //纯电池
      if (this.EditOrderReqEn.CargoIDs.indexOf(pure) >= 0) {
        let letTemp = this.getLstBatteryText(batReq, 1);
        lstBatteryText = lstBatteryText.concat(letTemp);
      }

      //内置电池
      if (this.EditOrderReqEn.InsideBattery &&
        (this.isShowBatteryCount(batReqStr) == false || this.EditOrderReqEn.BatteryCountType == 2)) {
        let letTemp = this.getLstBatteryText(batReq, 2);
        lstBatteryText = lstBatteryText.concat(letTemp);
      }

      //配套电池（锂电池）
      if (this.EditOrderReqEn.MatingBattery == 18 || this.EditOrderReqEn.MatingBattery == 19) {
        let letTemp = this.getLstBatteryText(batReq, 3);
        lstBatteryText = lstBatteryText.concat(letTemp);
      }

      //配套电池（干电池）
      if (this.EditOrderReqEn.MatingBattery == 17) {
        let letTemp = this.getLstBatteryText(batReq, 4);
        lstBatteryText = lstBatteryText.concat(letTemp);
      }

      //去重
      lstBatteryText = this.distinctArray(lstBatteryText);

      //合并成字符串
      let text = lstBatteryText.join(",");
      return text;
    },

    //获取指定类型的电池类型集合
    //batReq：电池货要求，如 [{"BatteryType":1,"RequiredInfo":[2,3],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[1,2,3,4,5],"OtherInfo":"256633"},{"BatteryType":3,"RequiredInfo":[0],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[0],"OtherInfo":null}]
    //batteryType：电池货要求类型，1：纯电池；2：内置电池；3：配套电池（锂电池）；4：配套电池（干电池）。
    getLstBatteryText(batReq, batteryType) {
      //电池类型集合
      let lstBatteryText = [];

      //遍历电池货要求
      batReq.forEach(e => {
        if (e.BatteryType == batteryType) {
          e.RequiredInfo.forEach(item => {
            switch (item) {
              case 1:
                lstBatteryText.push("MSDS");
                break;
              case 2:
                lstBatteryText.push("UN38.3");
                break;
              case 3:
                lstBatteryText.push("电池信");
                break;
              case 4:
                lstBatteryText.push(e.OtherInfo);
                break;
            }
          })

          return false; //结束循环
        }
      });

      return lstBatteryText;
    },

    //判断是否需要提供电池货资料
    //batID：电池货种类ID
    //batteryType：电池货要求类型 1：纯电池；2：内置电池；3：配套电池（锂电池）；4：配套电池（干电池）。
    //batReq：电池货要求，如 [{"BatteryType":1,"RequiredInfo":[2,3],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[1,2,3,4,5],"OtherInfo":"256633"},{"BatteryType":3,"RequiredInfo":[0],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[0],"OtherInfo":null}]
    isNeedBatDoc(batID, batteryType, batReq) {
      //判断结果
      let isNeed = false;

      //遍历电池货要求
      batReq.forEach(e => {
        if (e.BatteryType == batteryType && this.EditOrderReqEn.CargoIDs.indexOf(batID) >= 0) {
          if (e.RequiredInfo.length > 0 && $.inArray(0, e.RequiredInfo) < 0) {
            isNeed = true;
            return false; //结束循环
          }
        }
      });

      return isNeed;
    },

    //是否显示发电池货须知
    //batReqStr：电池货要求字符串，如 [{"BatteryType":1,"RequiredInfo":[2,3],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[1,2,3,4,5],"OtherInfo":"256633"},{"BatteryType":3,"RequiredInfo":[0],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[0],"OtherInfo":null}]
    isShowBatteryKnow(batReqStr) {
      if (!batReqStr) {
        return false;
      }

      let pure = '103'; //纯电池ID
      let builtIn = '108'; //内置电池ID
      let supporting = '109'; //配套电池ID

      //电池货要求
      let batReq = JSON.parse(batReqStr);

      //是否显示结果
      let isShow = false;

      //遍历电池货要求
      batReq.forEach(e => {
        //纯电池
        if (e.BatteryType == 1 && this.EditOrderReqEn.CargoIDs.indexOf(pure) >= 0) {
          isShow = true;
          return false; //结束循环
        }

        //内置电池
        if (e.BatteryType == 2 && this.EditOrderReqEn.CargoIDs.indexOf(builtIn) >= 0) {
          isShow = true;
          return false; //结束循环
        }

        //配套电池
        if ((e.BatteryType == 3 || e.BatteryType == 4) && this.EditOrderReqEn.CargoIDs.indexOf(supporting) >= 0) {
          isShow = true;
          return false; //结束循环
        }
      });

      return isShow;
    },

    //数组去重复
    distinctArray(arr) {
      var hash = [];
      for (var i = 0; i < arr.length; i++) {
        if (hash.indexOf(arr[i]) == -1) {
          hash.push(arr[i]);
        }
      }
      return hash;
    },
    //-----------------------------------电池货物信息-----------------------------------------------//

    //产品信息库新增
    getAddItem() {
      return { EnglishName: '', Material: '', Purpose: '', CustomsCode: '', Quanlity: null, Price: null }
    },
    //新增产品信息列表--加号按钮
    addExpCarItem() {
      this.OrderProductInfos.push(this.getAddItem());
    },
    //删除产品信息一条记录--减号按钮
    delExpCarItem(index) {
      if (this.OrderProductInfos.length > 1) {
        this.OrderProductInfos.splice(index, 1);
      }
    },

    ////-----------------------------------发票信息-----------------------------------------------////
    clkClaimTips() { //点击理赔条款
      this.$refs.claimRef.clkOpenBox()
    },


    //发票类型发票模板，请按渠道要求的模版提供发票接口数据，有模板要求就显示相应的模板，没有则显示默认通用发票模板：
    getInvTemp(chKey, couKey) {
      let that = this
      this.api.param = {
        channelKey: chKey,
        countryKey: couKey,
      };
      // this.api.url = this.$api01 + "/api/InfoCustomer/ExpChannel/QueryExpChannelInvoice";
      this.api.url = this.$api04 + "/Express/api/ExpChannel/QueryExpChannelInvoice";
      fetch(this.api.url, this.api.param).then(function (res) {
        if (res.Results.length > 0) {
          // that.templateInfo=res.Results
          that.invTemplate = res.Results[0].OriginalName;
          that.invTemplateUrl = res.Results[0].Url;
        } else {
          that.invTemplate = 'invoice-template-download.xls';
          // that.invTemplateUrl = that.$apiCh + 'Upload/invoice/InvoiceMod.xls';
          that.invTemplateUrl = that.$apiFileCloudFirst + '/Upload/invoice/InvoiceMod.xls';
        }
      })
    },
    //点击渠道发票模板下载，更改下载文件名称
    clkInvTem() {
      let mb = this.myExpBrowser();
      // if ('IE' == mb) {
      //   this.expNameIE(this.invTemplateUrl, this.invTemplate)
      // } else {
      //   this.expFileIE(this.invTemplateUrl, this.invTemplate)
      // }
      fileSteamDownload(this, {
        FullPath: this.invTemplateUrl, // 路径
        CurrentFileName: this.invTemplate // 文件名称
      }, this.invTemplate)
    },
    //只区分浏览器，不考虑版本
    myExpBrowser() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return "IE";  // 因为ie10-ie11的版本问题，不再支持document.all判断，所以ie判断函数要重新写了
      }
    },
    //下载文件  不兼容ie
    expFileIE(url, fileName) {
      // 创建隐藏的可下载链接
      var eleLink = document.createElement('a');
      eleLink.target = "_blank";
      eleLink.download = fileName;
      eleLink.style.display = 'none';
      eleLink.href = url;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();

      // 然后移除
      document.body.removeChild(eleLink);
    },
    //导出订单下载文件名修改并保存 兼容ie10+ 和 谷歌（Chrome）
    expNameIE(url, filename) {
      this.getBlob(url).then(blob => {
        this.saveAs(blob, filename);
      });
    },
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();

        window.URL.revokeObjectURL(link.href);
      }
    },
    //发票类型转换
    turnField(val) { //转换字段
      if (val == 1) return 'Paper invoice with goods';
      if (val == 2) return 'Paper invoice with goods';
      if (val == 3) return 'Upload invoice';
      if (val == 4) return 'Choose my invoice';
      return '';
    },
    //发票类型接口数据，判断显示渠道配置的发票类型--发票类型。1：随货正本发票。2：随货纸质发票，3：上传电子发票，4：在线制作发票
    getInvoiceTemplate(chKey, couKey) {
      let that = this
      this.api.param = {
        channelKey: chKey,
        countryKey: couKey,
      };
      //this.api.url = this.$api01 + "/api/InfoCustomer/ExpChannel/GetChannelInvoiceType";
      this.api.url = this.$api04 + "/Express/api/ExpChannel/GetChannelInvoiceType";
      fetch(this.api.url, this.api.param).then(function (res) {
        if (res.Results.length > 0) {
          that.InvoiceInfoPage.invTypeInfo = res.Results
        }
      })
    },
    //发票类型改变
    changeInvType(val) {
      if (this.EditOrderReqEn.PackageType == 1 && this.EditOrderReqEn.InvoiceType) {
        if (val == 4) {
          this.getInvoiceList(); //我的发票弹框列表数据
          this.showModal = true
          this.myInivoceBox = true
        };
        this.expShow = 0
        return true;
      } else {
        this.expShow = 5
        this.goToBat();
        return false;
      }
    },
    //点击选择我的发票按钮
    SelectInvoice() {
      this.getInvoiceList(); //我的发票弹框列表数据
      this.showModal = true
      this.myInivoceBox = true
    },
    //点击修改我的发票按钮 modify invoice
    modifyInvoiceBtn() {
      this.showModal = true
      this.invoInputBox = true
      this.shipDisabled = true //是否禁止修改发件人信息中的公司
      //点击保存按钮 产品信息库同步到上方的产品信息库
      let goodsInfoArr = []
      this.OrderProductInfos.forEach(e => {
        if (e.Quanlity == 0) {
          e.Quanlity = null
        };
        if (e.Price == 0) {
          e.Price = null
        };

        let objGoods = {
          Commodity: e.EnglishName,
          Material: e.Material,
          Use: e.Purpose,
          HSCode: e.CustomsCode,
          Qty: e.Quanlity,
          UnitPrice: e.Price,
        }
        goodsInfoArr.push(objGoods)
      })
      this.invoiceBackup.goodsInfoList = goodsInfoArr

      //  console.log('this.invoiceBackup  ' +  JSON.stringify(this.invoiceBackup))

      //收件人信息更改后同步到已选中的发票中
      if (this.invoiceBackup.consigContact) {
        this.invoiceBackup.consigContact = this.OrderContactInfos.Consignee
        this.invoiceBackup.consigCompany = this.OrderContactInfos.ConsigneeCompany
        this.invoiceBackup.consigTEL = this.OrderContactInfos.ConsigneeTel
        this.invoiceBackup.consigZipCode = this.OrderContactInfos.ConsigneeZipcode
        this.invoiceBackup.consigEmail = this.OrderContactInfos.ConsigneeEmail
        this.invoiceBackup.consigAddr = this.OrderContactInfos.ConsigneeAddress
        this.invoiceBackup.consigCountry = this.OrderContactInfos.ConsigneeCountry
        this.invoiceBackup.Country_Key = this.OrderContactInfos.ConsigneeCountryKey
        this.invoiceBackup.consigCity = this.OrderContactInfos.ConsigneeCity
      }

      // 收件人目的国家不能更改，并且只能是当前渠道的国家
      let DesCounInfo = {
        desCounNameEn: this.EditOrderReqEn.DestCountryNameEn,
        desCounKey: this.EditOrderReqEn.DestCountrKey
      }


      this.$refs.clkSubmit.editData(this.invoiceBackup, this.ordNo, this.shipDisabled, DesCounInfo);

      //this.invoiceBackup=this.myInvoiceInfo
    },

    //在我的发票弹框中点击<Making a new invoice>按钮,取收发件人默认信息，产品库默认信息
    //点击制作发票
    async clkMakeInvoice() {

      this.isMakeInvoice = true, //是否调用制作新发票接口
        this.shipDisabled = false, //是否禁止修改发件人信息中的公司
        this.ConsignorMsg = [],
        this.showModal = true,
        this.invoInputBox = true;
      this.InvoiceTitle = 'Making a new invoice'

      await this.getReDataAPI(); //收件人，默认数据
      await this.getCargoDataAPI(2); //产品库信息

      let prdList = []
      this.OrderProductInfos.forEach(e => {
        let prdObj = {
          EnglishName: e.EnglishName,
          Material: e.Material,
          CustomsCode: e.CustomsCode,
          Purpose: e.Purpose,
          Quanlity: null,
          Price: null,
          Unit: e.Unit,
        }
        prdList.push(prdObj)
      })
      this.pordDefultMsg = prdList

      //console.log('sd ' + JSON.stringify(this.pordDefultMsg));




      this.ordNo = this.$route.query.ord //货物订单号

      // 收件人目的国家不能更改，并且只能是当前渠道的国家
      let DesCounInfo = {
        desCounNameEn: this.EditOrderReqEn.DestCountryNameEn,
        desCounKey: this.EditOrderReqEn.DestCountrKey
      }
      this.myInvoiceInfo = null;
      this.$refs.clkSubmit.setData(this.ConsigDefaultMsg, this.ConsignorMsg, this.pordDefultMsg, this.myInvoiceInfo, this.ordNo, this.shipDisabled, DesCounInfo);
    },

    //选择我的发票-弹框
    clkSearInvoiceBtn() { //点击我的发票弹框里面搜索按钮
      this.getInvoiceList();
    },
    // 切换页码
    handleCurrentChangeMy(val) {
      this.currentPageMy = val;
      this.getInvoiceList(1);
    },
    //弹框发票列表接口数据 invoiceBoxList
    getInvoiceList(type = 0) {
      if (type == 0) {
        this.currentPageMy = 1;
        this.pageSizeMy = 20;
        this.totalMy = 0;
        this.invoiceBoxList = [];
      }
      let that = this
      that.api.param = {
        sendCompany: that.searchInvoiceInput,
        Page: that.currentPageMy,
        Size: that.pageSizeMy,
      }
      that.InvLoading = true //加载中
      that.InvNoData = false  //暂无查询数据
      that.InvoData = false
      // that.api.url = that.$api02 + '/api/EbayCustomer/MyInvoice/QueryMyInvoiceEn';
      that.api.url = that.$api04 + '/Basics/api/MyInvoice/QueryMyInvoiceEn';
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK) {
          that.InvLoading = false;
          res.Results.forEach(item => {
            that.$set(item, 'Id', item.ID);
          })
          if (res.Results && res.Results.length > 0) {
            that.InvoData = true
            that.InvNoData = false
          } else {
            that.InvNoData = true
          }

          that.invoiceBoxList = res.Results;
          that.totalMy = res.Total;
        } else {
          that.InvLoading = false
          that.InvoData = false
          that.InvNoData = true
        }
      })
    },

    //点击弹框选择按钮，判断地址库中公司是不是在黑名单中
    async IsBlacklistUser(Consignor, Company) {
      let that = this
      that.api.param = {
        ModeCode: that.EditOrderReqEn.BaseModeCode,//运输方式
        ConsignorName: Consignor, //寄件人名称
        CompanyName: Company,//公司名称
      }
      // that.api.url = that.$api03 + '/api/TradeCustomer/ConsignorBlacklist/IsBlacklistUser';
      that.api.url = that.$api04 + '/Basics/api/ConsignorBlacklist/IsBlacklistUser';
      await post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK) {
          that.IsBlacklistUserID = res.Results
        }
      })
    },

    //在我的发票弹框中点击<choose>按钮
    //第一步：根据收件人ID,获取发票详情信息，没有收件人ID则直接获取默认信息
    async chooseMyInvoice(item) {//选择我的弹框中--点击选择按钮
      await this.IsBlacklistUser(item.ConsignorName, item.ConsignorCompany)

      if (this.IsBlacklistUserID == false) {
        this.isMakeInvoice = false, //是否调用制作新发票接口
          this.shipDisabled = true, //是否禁止修改发件人信息中的公司
          this.myInivoceBox = false //关闭我的发票列表弹窗

        this.InvoiceInfoPage.TemplateInvoicePath = item.TemplateInvoicePath
        this.EditOrderReqEn.CusInvoiceInfoID = item.CusInvoiceInfoID  //我的发票ID
        //获取发件人信息赋值到我的发票组件中 
        if (item.ConsignorID > 0) {
          await this.getConsignorDataAPI(item.ConsignorID);
        }
        if (item.ConsigneeID) {
          await this.getInvoiceInfoApi(item.CusInvoiceInfoID)

          //当运输方式为FedEX/UPS，页面上有产品信息，页面上的产品信息覆盖发票里面的产品信息
          //产品信息数量和单件不显示
          let prdList = []
          if (this.isShowGoodsInfo()) {
            this.OrderProductInfos.forEach(e => {
              if (e.EnglishName || e.Material || e.CustomsCode || e.Purpose) {
                let prdObj = {
                  EnglishName: e.EnglishName,
                  Material: e.Material,
                  CustomsCode: e.CustomsCode,
                  Purpose: e.Purpose,
                  Quanlity: null,
                  Price: null,
                  Unit: 1,
                }
                prdList.push(prdObj)
              } else {
                this.myInvoiceInfo.ProductInfos.forEach(e => {
                  let prdObj = {
                    EnglishName: e.EnglishName,
                    Material: e.Material,
                    CustomsCode: e.CustomsCode,
                    Purpose: e.Purpose,
                    Quanlity: null,
                    Price: null,
                    Unit: 1,
                  }
                  prdList.push(prdObj)
                })
              }
            })



          } else {
            this.myInvoiceInfo.ProductInfos.forEach(e => {
              let prdObj = {
                EnglishName: e.EnglishName,
                Material: e.Material,
                CustomsCode: e.CustomsCode,
                Purpose: e.Purpose,
                Quanlity: null,
                Price: null,
                Unit: 1,
              }
              prdList.push(prdObj)
            })
          }
          this.myInvoiceInfo.ProductInfos = prdList
          this.ConsigDefaultMsg = null;
          this.pordDefultMsg = [];
        } else {
          await this.getReDataAPI();
          await this.getCargoDataAPI(2);
          this.myInvoiceInfo = null;
        }

        this.ordNo = this.$route.query.ord //货物订单号

        // 收件人目的国家不能更改，并且只能是当前渠道的国家
        let DesCounInfo = {
          desCounNameEn: this.EditOrderReqEn.DestCountryNameEn,
          desCounKey: this.EditOrderReqEn.DestCountrKey
        }



        //打开编辑我的发票
        this.invoInputBox = true;
        this.InvoiceTitle = 'Editing invoice'
        this.$refs.clkSubmit.setData(this.ConsigDefaultMsg, this.ConsignorMsg, this.pordDefultMsg, this.myInvoiceInfo, this.ordNo, this.shipDisabled, DesCounInfo);

      } else {
        this.$confirm('The shipper is the official ' + this.transportationID + ' shipping blacklist,please contact customer service for processing', '', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: 'Yes',
          cancelButtonText: '',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {

        }).catch(() => {

        });
        return false;
      }


    },
    //获取在我的发票页面编辑过后的的信息详情
    async getInvoiceInfoApi(CusInvoiceInfoID) {
      let that = this;
      // this.api.url = this.$api02 + "/api/EbayCustomer/MyInvoice/GetDetial/" + CusInvoiceInfoID;
      this.api.url = this.$api04 + "/Basics/api/MyInvoice/GetDetial/" + CusInvoiceInfoID;
      await fetch(this.api.url).then(function (res) {
        if (res.Results) {
          that.myInvoiceInfo = res.Results
        }
      })
    },
    //收件人信息默认值取值，赋值到我的发票上
    //收货地址接口
    async getReDataAPI() {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addressee/List';
      that.api.url = that.$api04 + "/Basics/api/Addressee/List";
      await post(that.api.url, {
        Page: 1,
        Size: 99999
      }).then(function (res) {
        if (res.Results) {
          res.Results.forEach(e => {
            if (e.Address_IsDefault == true) {
              that.ConsigDefaultMsg = e
            }
          })
        }
      })
    },
    //有发件人ID取发件人信息赋值到我的发票组件上
    async getConsignorDataAPI(ConsignorID) {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addresser/List';
      that.api.url = that.$api04 + '/Basics/api/Addresser/List';
      await post(that.api.url).then(function (res) {
        if (res.Results) {
          res.Results.forEach(e => {
            if (e.Address_ID == ConsignorID) {
              that.ConsignorMsg = e
            }
          })
        }
      })
    },
    //发票编辑保存按钮

    //-------提交表单的保存按钮-调用子组件方法------------//
    InvoiceSaveBtn() {
      this.$refs.clkSubmit.submitFormData();
    },
    //子组件点击提交的时候出发方法，并且传值到父组件中
    //发票组件传页面上的值过来
    invoiceByValue(invoiceValue) {
      this.invoiceBackup = invoiceValue
      console.log("=====invoiceValue",invoiceValue);
      if (invoiceValue) {
        this.InvoiceInfoPage.invTemplateChk = invoiceValue.shipperCompany
        this.InvoiceInfo = invoiceValue
        this.showModal = false;
        this.invoInputBox = false;
        this.myInivoceBox = false;
        //点击保存按钮 产品信息库同步到上方的产品信息库
        let goodsInfoArr = []
        invoiceValue.goodsInfoList.forEach(e => {
          let objGoods = {
            EnglishName: e.Commodity,
            Material: e.Material,
            Purpose: e.Use,
            CustomsCode: e.HSCode,
            Quanlity: e.Qty,
            Price: e.UnitPrice,
            Unit: e.Unit,
          }
          goodsInfoArr.push(objGoods)
        })
        this.OrderProductInfos = goodsInfoArr

        //点击保存按钮，发件人信息：如果3个必填项中任何一个值都没有填写，那么同步发票信息中的发件人信息，填写其中任意一个，则不同步
        if (!this.Shipper.ContactName && !this.Shipper.ContactTel && !this.Shipper.Email) {
          this.Shipper.Company = invoiceValue.shipperCompany
          this.Shipper.ContactName = invoiceValue.shipperContact
          this.Shipper.ContactTel = invoiceValue.shipperTEL
          this.Shipper.ZipCode = invoiceValue.shipperZipCode
          this.Shipper.Email = invoiceValue.shipperMail
          this.Shipper.Country = invoiceValue.shipperCountry
          this.Shipper.CountryKey = invoiceValue.shipperCountry_Key
          this.Shipper.Province = invoiceValue.shipperProv
          this.Shipper.ProvinceKey = invoiceValue.shipperProvKey
          this.Shipper.City = invoiceValue.shipperCity
          this.Shipper.CityKey = invoiceValue.shipperCity_Key
          this.Shipper.Address = invoiceValue.shipperAddr
        }
        //点击保存按钮，收件人信息同步发票信息
        //console.log('invoiceValue ' + JSON.stringify(invoiceValue))
        this.OrderContactInfos.Consignee = invoiceValue.consigContact
        this.OrderContactInfos.ConsigneeCompany = invoiceValue.consigCompany
        this.OrderContactInfos.ConsigneeTel = invoiceValue.consigTEL
        this.OrderContactInfos.ConsigneeEmail = invoiceValue.consigEmail
        this.OrderContactInfos.ConsigneeZipcode = invoiceValue.consigZipCode
        this.OrderContactInfos.ConsigneeCountryKey = invoiceValue.Country_Key
        this.OrderContactInfos.ConsigneeCountry = invoiceValue.consigCountry
        this.OrderContactInfos.ConsigneeCity = invoiceValue.consigCity
        this.OrderContactInfos.ConsigneeAddress = invoiceValue.consigAddr
        this.OrderContactInfos.ConsigneeID = invoiceValue.consigID || 0

        //把发票里面的金额带入保险金额中
        //console.log('invoiceValue ' +  JSON.stringify(invoiceValue.goodsInfoList)) this.invoiceBackup
        let sunVal = 0
        invoiceValue.goodsInfoList.forEach(k => {
          sunVal += k.Qty * k.UnitPrice
        })
        this.goodsSumVal = sunVal

        this.OrderInsuranceInfos.BuyAmount = this.goodsSumVal
      }
      if (this.isMakeInvoice == true) {
        this.saveNewInvoiceApi(invoiceValue);
      }
    },

    //点击制作新发票 按保存按钮，直接调用保存发票接口
    //点击制作新发票保存接口
    saveNewInvoiceApi(invoiceValue) {
      let that = this
      that.api.param = {
        CommercialINvoice: 'COMMERCIAL INVOICE',
        InvoiceNO: invoiceValue.InvoiceNo, //合同编号
        DateofExportation: new Date(invoiceValue.DateofExportation).Format('yyyy-MM-dd'), //合同日期
        CountryofOrigin: invoiceValue.originalCountry, //原产地
        WaybillNO: invoiceValue.WaybillNO, //订单号
        TemplateInvoicePath: '/myInfo/CommonInvoice', //发票路径
        //发件人信息
        ShipperID: invoiceValue.InvoiceNo, //发件人ID
        ShipperCompany: invoiceValue.shipperCompany,
        ShipperContact: invoiceValue.shipperContact,
        ShipperTel: invoiceValue.shipperTEL,
        ShipperAddress: invoiceValue.shipperAddr,
        ShipperProKey: invoiceValue.shipperProvKey,
        ShipperProName: invoiceValue.shipperProv,
        ShipperCityKey: invoiceValue.shipperCity_Key,
        ShipperCityName: invoiceValue.shipperCity,

        //收件人信息      
        ConsigneeID: invoiceValue.InvoiceNo || 0, //收件人ID
        ConsigneeCompany: invoiceValue.consigCompany,
        ConsigneeContact: invoiceValue.consigContact,
        ConsigneeTel: invoiceValue.consigTEL,
        ConsigneeCountryKey: invoiceValue.Country_Key,
        ConsigneeCountryName: invoiceValue.consigCountry,
        ConsigneeZipCode: invoiceValue.consigZipCode,
        ConsigneeAddress: invoiceValue.consigAddr,
        ConsigneeCityName: invoiceValue.consigCity,

        //产品对象集合
        // ProductInfos:[],
      }
      //产品对象集合
      let porductArrJson = []
      invoiceValue.goodsInfoList.forEach(e => {
        let porductArr = {
          EnglishName: e.Commodity,
          Material: e.Material,
          CustomsCode: e.HSCode,
          Purpose: e.Use,
          Quanlity: e.Qty,
          Price: e.UnitPrice,
        }
        porductArrJson.push(porductArr)
      })
      that.api.param.ProductInfos = porductArrJson

      // that.api.url = that.$api02 + '/api/EbayCustomer/MyInvoice/SaveInvoiceEn';
      that.api.url = that.$api04 + '/Basics/api/MyInvoice/SaveInvoiceEn';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.EditOrderReqEn.CusInvoiceInfoID = res.Results.CusInvoiceInfoID  //我的发票ID
        }
      })
    },

    //-----------保险信息----------------------//
    //点击购买保险，把收件人公司名带入投保公司
    chgIsBuy() {
      if (this.OrderInsuranceInfos.IsBuy == true && !this.OrderInsuranceInfos.Beneficiary) {
        this.OrderInsuranceInfos.Beneficiary = this.OrderContactInfos.ConsigneeCompany
      }
    },
    //保险验证
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 2) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 3);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }

        return ctrValue;
      }
    },


    ////-----------------------------------费用信息-----------------------------------------------////
    // pickupFee:null,//提货-取件费 freightFee:null,//运费
    //获取运费接口
    //运费计算接口，显示运费计费重，单价，运费
    getExpFeeInfo(item) {
      let that = this
      this.api.param = {
        GoodsReadyTime: new Date(item.order.GoodsReadyTime).Format('yyyy-MM-dd'),//货好时间
        channelKey: item.order.ChannelKey,
        CountryKey: item.order.DestCountryKey,
        PacketType: item.order.PackageType,
        Weight: item.order.OrderWeight,
        CBM: item.order.OrderVolume,
        IsCalcDisableChannel: true,
      };
      //this.api.url = this.$api01 + "/api/InfoCustomer/ExpCalculation/CalcTrafficEN";
      this.api.url = this.$api04 + "/Express/api/ExpCalculation/CalcTrafficEN";
      post(this.api.url, this.api.param).then(function (res) {
        //运费
        if (res.Results) {
          if (res.Results.IsDiscount == true) {
            that.freightFee = res.Results.DiscountTrafficAmount
          } else if (res.Results.IsDiscount == false) {
            that.freightFee = res.Results.TrafficAmount
          }
        }
      })
    },
    //获取费用计算单位
    conversioUnit(Code, hasBill) {
      if (Code == 1) {
        if (hasBill) {
          return 'Bill'
        }
        return 'B\\L'
      }
      if (Code == 2) return 'KG'
      if (Code == 3) return 'Unit'
      if (Code == 4) return 'Pcs'
      if (Code == 5) return '台'
      if (Code == 6) return 'CBM'
      if (Code == 7) return 'Time'
    },

    //可能产生的附加费接口数据、还有必收附加费，匹配到的附加费接口数据 OrderExtraFeeInfos
    //附加服务费用接口
    getCostInfoAPI(item) {
      let that = this
      let goodsStrArr = item.order.CargoIDs.split(',')
      let goodsIntArr = []
      //方法一  把字符串数组转换成整型数组
      //        dataStrArr.forEach(function(data,index,arr){
      //          dataIntArr.push(+data);
      //        });
      //方法二  把字符串数组转换成整型数组
      goodsIntArr = goodsStrArr.map(function (data) {
        return +data;
      });

      this.api.param = {
        channelKey: item.order.ChannelKey,
        countryKey: item.order.DestCountryKey,
        packetType: item.order.PackageType,
        returnCurrency: 2, //币种1：人民币 2：美元
        cargoTypeIDs: goodsIntArr, //货物
        queryType: item.order.QueryType, // 1：总量计算，2：每件计算
        quanlity: item.order.OrderCount, //总件数
        weight: item.order.OrderChargeWeight,//计费重量
        goodInfos: item.volumeList,
        DeliveryKey: item.order.QueryStartCityKey, //交货地key
        RealWeight: item.order.OrderWeight, //总实重
        CBM: item.order.OrderVolume,//总体积
      };
      //this.api.url = this.$api01 + "/api/InfoCustomer/ExpChannel/QueryExpChannelFeeEN";
      this.api.url = this.$api04 + "/Express/api/ExpChannel/QueryExpChannelFeeEN";
      post(this.api.url, this.api.param).then(function (res) {
        // OrderExtraFeeInfos:[],//必收附加费 OrderFeeInfo2:[],//可能产生的附加费
        if (res.Results) {
          res.Results.forEach((info) => {
            //显示在预估费用的弹窗中的必收费用和匹配到的费用 OrderExtraFeeInfos
            // if (info.RelatedService == 0 && (info.FeeSelectType == 1 || info.FeeSelectType == 2)) {
            //   that.OrderExtraFeeInfos.push(info)  //必收的附加费
            // }
            if (![3, 5].includes(info.FeeSelectType)) {
              that.OrderExtraFeeInfos.push(info)  //必收的附加费
            }


            //可能产生的附加费
            if (info.RelatedService == 0 && info.FeeSelectType == 3) {
              that.OrderFeeInfo2.push(info)  //可能产生的附加费
            };
          })
          let data = that.OrderExtraFeeInfos.filter((feeItem) => {
            return feeItem.IsAddFreight == true
          });
          console.log(data, "data");
          data.forEach((item) => {
            let mergeData = that.waysCostNum(item).toFixed(2)
            that.Surcharge = Number(mergeData) + that.Surcharge
          })
          //一般贸易报关服务，变更为勾选项目，金额不变“35usd/票”
          that.OrderFeeInfo2.push({
            FeeNameEn:'General Customs Clearance',
            FeeNameCh:'一般贸易报关-出口',
            FeeItemID:61,
            CustomerRemarkEn:'',
            Amount:35,
            CostUnit:1,
            ChargeQuanlity:1,
            FeeSelectType:3,
            RelatedService:1,
          })

          //可能产生的附加费
          if (that.OrderFeeInfo2) {
            that.OrderFeeInfo2.forEach((item) => {
              Vue.set(item, "checked", false);
            })
            console.log(that.OrderFeeInfo2, " that.OrderFeeInfo2");
          }
        }
        //that.getChkFeeInfo(); //调用方法
      })
    },
    //勾选的可能产生的附加费增加到必收的数组中
    changeChedFee(item) {
      if (item.checked == true) {
        this.OrderExtraFeeInfos.push(item)  //必收的附加费
      } else {
        this.OrderExtraFeeInfos.forEach((e, index) => {
          if (e.FeeItemID == item.FeeItemID) {
            this.OrderExtraFeeInfos.splice(index, 1);
            return false; //结束循环
          }
        })
      }
    },

    //可能产生的附加费用，计算
    //列表选择费用计算
    waysCostNum(info) {
      //总金额大于最大值时显示最大值，总金额小于最小值时显示最小值
      //fe.Amount * fe.ChargeQuanlity
      let amount = info.Amount * info.ChargeQuanlity;
      if (info.MaxValue && info.MaxValue < amount) {
        amount = info.MaxValue;
      } else if (info.MinValue && info.MinValue > amount) {
        amount = info.MinValue;
      }
      return Number(amount.toFixed(2));
    },
    ////-----------------------------------弹框信息方法-----------------------------------------------////
    getClose() { //关闭弹窗总方法
      this.showModal = false,//遮罩层
        this.ShipperBox = false//发件人选择弹框
      this.ConsigneeBox = false //收件人弹框
      this.proInfoBox = false //产品信息弹框
      this.myInivoceBox = false //选择我的发票弹框
      this.invoInputBox = false //

      this.$refs.clkSubmit.submitCancel(); //我的发票弹框提示清除
      //this.$refs.fromInvoInfo.resetFields(); //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
    },

    //点击选择发件人按钮
    clkShippBox() {
      this.getShipperListApi();
      this.showModal = true,//遮罩层
        this.ShipperBox = true//发件人选择弹框
    },
    //获取发件人弹框信息
    getShipperListApi() {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addresser/List';
      that.api.url = that.$api04 + '/Basics/api/Addresser/List';
      post(that.api.url).then(function (res) {
        if (res.Results) {
          that.ShipperBoxList = res.Results;
        }
      })
    },
    //点击发件人弹框选择按钮，赋值到发件人信息中
    clkShipSelect(item) {
      //console.log('item  '+JSON.stringify(item))
      if (this.EditOrderReqEn.PackageType == 1) {
        this.Shipper.Company = item.company
        this.Shipper.ContactName = item.Address_Name
        this.Shipper.ContactTel = item.Address_Tel
        this.Shipper.ZipCode = item.Address_ZIPCode
        this.Shipper.Email = item.Address_Mail
        this.Shipper.CountryKey = item.Country_Key
        this.Shipper.Country = item.SendCountryNameEn
        this.Shipper.ProvinceKey = item.City_Key
        this.Shipper.Province = item.SendProvinceEn
        this.Shipper.CityKey = item.City_Key
        this.Shipper.City = item.SendCitynameEn
        this.Shipper.Address = item.Address_Street
      } else if (this.EditOrderReqEn.PackageType == 2) {

        this.OrderDocInfos.ConsignorCompany = item.company
        this.OrderDocInfos.Consignor = item.Address_Name
        this.OrderDocInfos.ConsignorTel = item.Address_Tel
        this.OrderDocInfos.ConsignorZipcode = item.Address_ZIPCode
        this.OrderDocInfos.ConsignorEmail = item.Address_Mail

        this.OrderDocInfos.ConsignorProvinceKey = item.City_Key
        this.OrderDocInfos.ConsignorProvince = item.SendProvinceEn
        this.OrderDocInfos.ConsignorCityKey = item.City_Key
        this.OrderDocInfos.ConsignorCity = item.SendCitynameEn
        this.OrderDocInfos.ConsignorAddress = item.Address_Street

        this.getChinaCityInfo(this.OrderDocInfos.ConsignorCity);//调用中国城市接口 
      }


      this.showModal = false,//遮罩层
        this.ShipperBox = false//发件人选择弹框
    },

    //点击选择收件人按钮
    clkConsigBox() {
      this.getConsigneeList()
      this.showModal = true,//遮罩层
        this.ConsigneeBox = true //收件人弹框
    },

    //获取收件人弹框信息
    getConsigneeList() {
      let that = this;
      that.api.param = {
        CountryKey: that.EditOrderReqEn.DestCountrKey,
        Page: 1,
        Size: 99999
      }
      // if(this.EditOrderReqEn.PackageType==2){
      //   that.api.param.CountryKey=this.OrderDocInfos.ConsigneeCountryKey
      // }

      // that.api.url = that.$api02 + '/api/EbayCustomer/Addressee/List';
      that.api.url = that.$api04 + "/Basics/api/Addressee/List";
      post(that.api.url, that.api.param).then(function (res) {
        that.ConsigneeBoxList = res.Results;
      })
    },
    //点击收件人弹框选择按钮，赋值到发件人信息中
    clkConsSelect(item) {
      if (this.EditOrderReqEn.PackageType == 1) {
        this.OrderContactInfos.ConsigneeCompany = item.company
        this.OrderContactInfos.Consignee = item.Address_Name
        this.OrderContactInfos.ConsigneeTel = item.Address_Tel
        this.OrderContactInfos.ConsigneeZipcode = item.Address_ZIPCode
        this.OrderContactInfos.ConsigneeEmail = item.Address_Mail
        this.OrderContactInfos.ConsigneeCountryKey = item.Country_Key
        this.OrderContactInfos.ConsigneeCountry = item.RecCountryNameEn
        this.OrderContactInfos.ConsigneeCity = item.Address_City
        this.OrderContactInfos.ConsigneeAddress = item.Address_Street
      } else if (this.EditOrderReqEn.PackageType == 2) {
        this.OrderDocInfos.ConsigneeCompany = item.company
        this.OrderDocInfos.Consignee = item.Address_Name
        this.OrderDocInfos.ConsigneeTel = item.Address_Tel
        this.OrderDocInfos.ConsigneeZipcode = item.Address_ZIPCode
        this.OrderDocInfos.ConsigneeEmail = item.Address_Mail
        this.OrderDocInfos.ConsigneeCity = item.Address_City
        this.OrderDocInfos.ConsigneeAddress = item.Address_Street
      }

      this.showModal = false,//遮罩层
        this.ConsigneeBox = false//收件人弹框
    },

    ////--------------------------------文件下单收发件人信息---------------------------------------------//
    //发件人城市数据
    shipperRemoteMethod(query) {
      if (query != '') {
        this.loading = true;
        this.getChinaCityInfo(query);
      } else {
        this.chCityOptions = [];
      }
    },
    //中国城市数据接口
    getChinaCityInfo(query) {
      // console.log('query '  +  query) 
      let that = this
      that.api.param = {
        "CityName": query,
        "Type": 'Ch', //Ch:查中国城市数据  En：查海外城市数据
        "Take": 50,
      }
      // that.api.url = that.$api02 + '/api/EbayCustomer/City/GetStartCityQuery'
      that.api.url = that.$api04 + '/Basics/api/SysRegion/GetStartCityQuery'
      post(that.api.url, that.api.param).then(function (res) {
        that.chCityOptions = res.Results
        that.loading = false;

        // that.fromInvoInfo.shipperCity_Key=that.fromInvoInfo.shipperCity_Key 
      })
    },
    //中国城市值改变
    changeChCityKey() {
      if (this.chCityOptions) {
        this.chCityOptions.forEach(e => {
          if (e.CityKey == this.OrderDocInfos.ConsignorCityKey) {
            this.OrderDocInfos.ConsignorCity = e.CityNameEn
            this.OrderDocInfos.ConsignorProvince = e.Province_NameEn
            this.OrderDocInfos.ConsignorProvinceKey = e.ProvinceKey
          }
        })
      }
      //中国城市值改变的时候验证
      if (this.OrderDocInfos.ConsignorCityKey) {
        this.expShow = 0
      } else {
        this.expShow = 7
      }
    },
    //海外城市数据接口
    getCityInfo(query) {
      let that = this
      that.api.param = {
        countryKey: that.OrderDocInfos.ConsigneeCountryKey,
        cityName: query,
        take: 100,
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/ForeignCity/QueryForeignCtiy'
      fetch(that.api.url, that.api.param).then(function (res) {
        that.EnCityOptions = res.Results
        that.loading = false;
      })
    },
    //收件人城市方法
    remoteMethod(query) {
      if (query != '') {
        this.loading = true;
        this.getCityInfo(query);
      } else {
        this.EnCityOptions = [];
      }
    },
    chaneCityKey() { //城市值改变
      let val = $.trim(this.OrderDocInfos.ConsigneeCity)
      if (!val) {
        this.EnCityOptions = []
        this.expShow = 8
        return false
      } else {
        this.expShow = 0
        return true
      }
    },

    //--------------------------------提交订单---------------------------------------------//
    //验证  that.OrderInsuranceInfos.BuyAmount=that.goodsSumVal //给货物保险投保金额赋值

    //有内置电池验证
    batInfoNZ() {
      if (this.isShowInsideBat == true) {
        if (this.isShowInsideBat && this.EditOrderReqEn.InsideBattery) {
          this.expShow = 0
          return true
        } else if (this.isShowInsideBat && !this.EditOrderReqEn.InsideBattery) {
          this.expShow = 1
          this.goToBat();
          return false
        }
      } else {
        return true
      }

    },
    //有配套电池验证
    batInfoPT() {
      if (this.isShowMatBat == true) {
        //包含货物，配套电池
        if (this.isShowMatBat && this.EditOrderReqEn.MatingBattery) {
          this.expShow = 0
          return true
        } else if (this.isShowMatBat && !this.EditOrderReqEn.MatingBattery) {
          this.expShow = 2
          this.goToBat();
          return false
        }
      } else {
        return true
      }

    },
    //未选择电池资料个数
    chgType() {
      if (this.isShowBatteryCount(this.EditOrderReqEn.BatteryRequired)) {
        if (!this.EditOrderReqEn.BatteryCountType) {
          this.expShow = 3
          this.goToBat();
          return false
        } else {
          this.expShow = 0
          return true
        }
      } else {
        return true
      }

    },
    //有电池资料的时候，未选择
    chgBatInfo() {
      //提交订单的时候，选择无电池资料
      if (this.isShowBatteryInfo(this.EditOrderReqEn.BatteryRequired)) {
        if (this.EditOrderReqEn.BatterySelectInfo == null) {
          this.expShow = 4
          this.goToBat();
          return false
        }
        if (this.EditOrderReqEn.BatterySelectInfo == 'MSDS,UN38.3') {
          this.expShow = 0
          return true
        } else {
          this.expShow = 0
          return false
        }
      } else {
        return true
      }

    },


    //有无电池资料选择无时不给提交,定位滚动上去
    goToBat() {
      $("html,body").animate({ scrollTop: $("#positionId").offset().top }, 800);
    },

    goToBat2() {
      $("html,body").animate({ scrollTop: $("#goodInvoice").offset().top }, 800);
    },

    //保险验证 //投保金额不能超过申报价值
    blurInsurance() {
      if (this.OrderInsuranceInfos.IsBuy == true && this.EditOrderReqEn.InvoiceType == 4) {
        if (this.OrderInsuranceInfos.BuyAmount > this.goodsSumVal) {
          this.isRedInsur = true
          return false
        } else {
          this.isRedInsur = false
          return true
        }
      } else {
        this.isRedInsur = false
        return true
      }
    },

    //验证货物价值是不是大于等于600.大于等于600则提示他不够买保险的风险
    async IsBuyInvo() {
      let isOK = true;
      if (this.OrderInsuranceInfos.IsBuy == false && this.goodsSumVal >= 600) {
        await this.$confirm('For goods worth more than 600USD, it is recommended to buy insurance. If you do not buy insurance, if the express company is responsible for any damage, the express company will only pay at most USD100 per shipment.', 'hint', {
          customClass: 'custom-message-box', //自定义添加Class
          confirmButtonText: 'I agree with',
          cancelButtonText: "I don't agree with",
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
          // showCancelButton:false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => {
          isOK = true
        }).catch(() => {
          this.OrderInsuranceInfos.IsBuy = true
          this.goToBat2();
          isOK = false
        });
      }
      return isOK
    },

    //点击提交订单按钮
    async clkSubOrd() {
      //验证方法
      let isCheck = this.getCheckForm();
      if (!isCheck) {
        return false
      }

      if (this.EditOrderReqEn.PackageType == 1) {
        //有无内置电池
        if (!this.batInfoNZ() || !this.batInfoPT() || !this.chgType()) {
          return false
        }
        //选择电池资料
        if (!this.chgBatInfo()) {
          this.goToBat();
          return false
        }

        if (!this.changeInvType()) {
          return false
        }
        //选这上传电子发票的时候，上传附件列表不能为空 
        if (this.EditOrderReqEn.InvoiceType == 3 && this.OrderUploadFilesInfos.length <= 0) {
          this.expShow = 6
          this.goToBat();
          return false;
        }
        //选择我的发票，但是实际没有选中发票
        if (this.EditOrderReqEn.InvoiceType == 4 && !this.InvoiceInfoPage.invTemplateChk) {
          this.$confirm('Please select an invoice!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false;
        }
        //如果选择了发票后，在上面添加产品信息，那么发票里面的产品信息 数量和单位还没有填写，则提示“请完善发票信息”
        let isTrue = true
        if (this.EditOrderReqEn.InvoiceType == 4 && this.InvoiceInfoPage.invTemplateChk) {
          this.OrderProductInfos.forEach(e => {
            if (!e.EnglishName || !e.Quanlity || !e.Price) {
              isTrue = false
            }
          })
        }
        if (isTrue == true) {

        } else {
          this.$confirm('Please complete your invoice information.', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false
        }
        if (!this.blurInsurance()) {
          return false;
        }
      } if (this.EditOrderReqEn.PackageType == 2) {
        //验证发件人城市是否空
        if (!this.OrderDocInfos.ConsignorCityKey) {
          this.expShow = 7
          this.goToBat();
          return false
        };
        //验证收件人城市是否为空
        // if(!this.OrderDocInfos.ConsigneeCity){
        //   this.expShow=8
        //   this.goToBat();
        //   return false
        // }

      }
      //货物价值超过600，是否购买保险提示
      // if(! await this.IsBuyInvo()){
      //   return false
      // }
      if (! await this.IsBuyInvo()) {
        return false
      }


      this.isOrdBtnGray = true

      //验证通过调用接口
      this.clkSubOrdApi();
    },

    //提交订单接口
    clkSubOrdApi() {
      let that = this;
      // console.log('this.OrderExtraFeeInfos  '  +  JSON.stringify(this.OrderExtraFeeInfos))
      this.api.param = {}
      this.api.param = this.EditOrderReqEn
      //if (!this.EditOrderReqEn.ConsigneeID) {
      this.api.param.ConsigneeID = !this.EditOrderReqEn.ConsigneeID ? this.OrderContactInfos.ConsigneeID : 0
      //}
      

      console.log('this.InvoiceInfo  '  + JSON.stringify(this.InvoiceInfo))
      //收发件人信息，如果没有选择发票，那么发件人信息等于shipper信息
      if (this.EditOrderReqEn.PackageType == 1) { //下单类型为包裹的时候
        if (this.EditOrderReqEn.InvoiceType != 4) {
          this.api.param.OrderContactInfos = {
            //发件人信息
            Consignor: this.Shipper.ContactName,
            ConsignorCompany: this.Shipper.Company,
            ConsignorTel: this.Shipper.ContactTel,
            ConsignorEmail: this.Shipper.Email,
            ConsignorZipcode: this.Shipper.ZipCode,
            ConsignorCountry: this.Shipper.Country,
            ConsignorProvince: this.Shipper.Province,
            ConsignorProvinceKey: this.Shipper.ProvinceKey,
            ConsignorCity: this.Shipper.City,
            ConsignorCityKey: this.Shipper.CityKey,
            ConsignorAddress: this.Shipper.Address,
            ConsignorID: null,
            //收件人信息
            Consignee: this.OrderContactInfos.Consignee,
            ConsigneeCompany: this.OrderContactInfos.ConsigneeCompany,
            ConsigneeTel: this.OrderContactInfos.ConsigneeTel,
            ConsigneeEmail: this.OrderContactInfos.ConsigneeEmail,
            ConsigneeZipcode: this.OrderContactInfos.ConsigneeZipcode,
            ConsigneeCountry: this.OrderContactInfos.ConsigneeCountry,
            ConsigneeCountryKey: this.OrderContactInfos.ConsigneeCountryKey,
            ConsigneeCity: this.OrderContactInfos.ConsigneeCity,
            ConsigneeAddress: this.OrderContactInfos.ConsigneeAddress,
            ConsigneeID: this.OrderContactInfos.ConsigneeID || 0,
          }
          this.api.param.InvoiceInfo = null //发票信息

          if (this.isShowGoodsInfo()) {
            ////产品信息
            let goodsInfo = []
            this.OrderProductInfos.forEach(e => {
              let arrPro = {
                EnglishName: e.EnglishName,
                Material: e.Material,
                Purpose: e.Purpose,
                HSCode: e.CustomsCode,
                Price: e.Price || 0,
                Quanlity: e.Quanlity || 0,
                Unit: e.Unit,
              }
              goodsInfo.push(arrPro)
            })
            this.api.param.OrderProductInfos = goodsInfo //产品信息

          } else {
            this.api.param.OrderProductInfos = null
          }

        } else if (this.EditOrderReqEn.InvoiceType == 4) {

          this.api.param.OrderContactInfos = {
            //发件人信息
            Consignor: this.InvoiceInfo.shipperContact,
            ConsignorCompany: this.InvoiceInfo.shipperCompany,
            ConsignorTel: this.InvoiceInfo.shipperTEL,
            ConsignorEmail: this.InvoiceInfo.shipperMail,
            ConsignorZipcode: this.InvoiceInfo.shipperZipCode,
            ConsignorCountry: this.InvoiceInfo.shipperCountry,
            ConsignorProvince: this.InvoiceInfo.shipperProv,
            ConsignorProvinceKey: this.InvoiceInfo.shipperProvKey,
            ConsignorCity: this.InvoiceInfo.shipperCity,
            ConsignorCityKey: this.InvoiceInfo.shipperCity_Key,
            ConsignorAddress: this.InvoiceInfo.shipperAddr,
            //ConsignorID:null,
            //收件人信息
            Consignee: this.OrderContactInfos.Consignee,
            ConsigneeCompany: this.OrderContactInfos.ConsigneeCompany,
            ConsigneeTel: this.OrderContactInfos.ConsigneeTel,
            ConsigneeEmail: this.OrderContactInfos.ConsigneeEmail,
            ConsigneeZipcode: this.OrderContactInfos.ConsigneeZipcode,
            ConsigneeCountry: this.OrderContactInfos.ConsigneeCountry,
            ConsigneeCountryKey: this.OrderContactInfos.ConsigneeCountryKey,
            ConsigneeCity: this.OrderContactInfos.ConsigneeCity,
            ConsigneeAddress: this.OrderContactInfos.ConsigneeAddress,
            ConsigneeID: this.OrderContactInfos.ConsigneeID || 0,
          }
          //this.api.param.OrderContactInfos=this.OrderContactInfos //收发件人信息

          this.api.param.InvoiceInfo = {
            InvoiceHeader: 'COMMERCIAL INVOICE',
            CommercialINvoice: 'COMMERCIAL INVOICE',
            WaybillNO: this.InvoiceInfo.WaybillNO,
            InvoiceNO: this.InvoiceInfo.InvoiceNo,
            DateofExportation: new Date(this.InvoiceInfo.DateofExportation).Format('yyyy-MM-dd'),
            CountryofOrigin: this.InvoiceInfo.originalCountry,
          }
          //this.api.param.InvoiceInfo=this.InvoiceInfo  //发票信息

          ////产品信息
          let goodsInfo = []
          this.OrderProductInfos.forEach(e => {
            let arrPro = {
              EnglishName: e.EnglishName,
              Material: e.Material,
              Purpose: e.Purpose,
              HSCode: e.CustomsCode,
              Price: e.Price || 0,
              Quanlity: e.Quanlity || 0,
              Unit: e.Unit,
            }
            goodsInfo.push(arrPro)
          })
          this.api.param.OrderProductInfos = goodsInfo //产品信息

        }

        this.api.param.Shipper = this.Shipper   //shipper 信息

        this.api.param.OrderUploadFilesInfos = this.OrderUploadFilesInfos //文件

      } else if (this.EditOrderReqEn.PackageType == 2) {//下单类型为文件的时候
        console.log("====文件下单===");
        this.api.param.OrderUploadFilesInfos = []
        if (this.OrderDocInfos.Consignor == null) {
          this.OrderDocInfos.Consignor = ''
        }
        this.api.param.OrderContactInfos = {
          //发件人信息
          Consignor: this.OrderDocInfos.Consignor,
          ConsignorCompany: this.OrderDocInfos.ConsignorCompany,
          ConsignorTel: this.OrderDocInfos.ConsignorTel,
          ConsignorEmail: this.OrderDocInfos.ConsignorEmail,
          ConsignorZipcode: this.OrderDocInfos.ConsignorZipcode,
          ConsignorCountry: this.OrderDocInfos.ConsignorCountry,
          ConsignorProvince: this.OrderDocInfos.ConsignorProvince,
          ConsignorProvinceKey: this.OrderDocInfos.ConsignorProvinceKey,
          ConsignorCity: this.OrderDocInfos.ConsignorCity,
          ConsignorCityKey: this.OrderDocInfos.ConsignorCityKey,
          ConsignorAddress: this.OrderDocInfos.ConsignorAddress,
          //收件人信息
          Consignee: this.OrderDocInfos.Consignee,
          ConsigneeCompany: this.OrderDocInfos.ConsigneeCompany,
          ConsigneeTel: this.OrderDocInfos.ConsigneeTel,
          ConsigneeEmail: this.OrderDocInfos.ConsigneeEmail,
          ConsigneeZipcode: this.OrderDocInfos.ConsigneeZipcode,
          ConsigneeCountry: this.OrderDocInfos.ConsigneeCountry,
          ConsigneeCountryKey: this.OrderDocInfos.ConsigneeCountryKey,
          ConsigneeCity: this.OrderDocInfos.ConsigneeCity,
          ConsigneeAddress: this.OrderDocInfos.ConsigneeAddress,
          ConsigneeID: this.OrderDocInfos.ConsigneeID || 0,
        }
        this.api.param.OrderProductInfos = null //产品信息
        this.api.param.InvoiceInfo = null  //我的发票信息
        this.api.param.InvoiceType = 0  //我的发票信息
      }

      //费用项
      let OrderExtraFeeArr = []
      this.OrderExtraFeeInfos.forEach(info => {
        let JSONItem = {
          FeeID: info.FeeItemID,
          FeeName: info.FeeNameCh,
          FeeEnName: info.FeeNameEn,
          Price: info.Amount,
          Quanlity: parseInt(info.ChargeQuanlity),
          Amount: this.waysCostNum(info),
          RelatedService: info.RelatedService,
          FeeSelectType: info.FeeSelectType,
        }
        OrderExtraFeeArr.push(JSONItem)
      })
      this.api.param.OrderExtraFeeInfos = OrderExtraFeeArr //费用


      if (this.OrderInsuranceInfos.IsBuy == true) {
        this.api.param.OrderInsuranceInfos = this.OrderInsuranceInfos //保险
      } else {
        this.api.param.OrderInsuranceInfos = null //保险
      }

      this.api.param.Currency = 2 //币种

      this.api.param.CusInvoicePath = this.InvoiceInfo.TemplateInvoicePath  //发票路径
      if (this.thInfo) {
        this.api.param.thInfo = this.thInfo //取件查价信息
      }
      this.api.param.WaybillNO = this.$route.query.ord;
      this.api.param.Is_login = true;
      this.api.param.Entrance = "EXPRESS";
      this.api.param.Platform_type = "web";
      console.log("========参数====",this.api.param);

      // this.api.url = this.$api03 + "/api/TradeCustomer/ExpNewOrder/UpdateEn";
      this.api.url = this.$api04 + "/Express/api/ExpNewOrder/UpdateEn";
      post(this.api.url, this.api.param).then(function (res) {


        //that.submitOrder(that.EditOrderReqEn.WaybillNO,that.EstimateCost,'','EXPRESS',that.EditOrderReqEn.StartCityNameEn,'',that.EditOrderReqEn.DestCountryNameEn,'',
        //that.EditOrderReqEn.CargoDescs,
        //that.orderInfo.OrderWeight,that.orderInfo.OrderVolume,that.orderInfo.OrderCount,that.orderInfo.OrderChargeWeight,that.turnField(that.EditOrderReqEn.InvoiceType),that.orderInfo.ChannelName,that.freightFee,'','',false)


        that.isOrdBtnGray = false
        if (res.IsOK == true) {
          //window.location.href="/exp/expSucceed?ord="+that.$route.query.ord+'&ordCost='+that.EstimateCost+'&shipperEmali='+that.Shipper.Email
          //that.isOrdBtnGray=false
          that.$router.push({ path: '/exp/expSucceed', query: { ord: that.$route.query.ord, ordCost: that.EstimateCost, shipperEmali: that.Shipper.Email } });
        } else if (res.IsOK == false) {
          if (res.Status.Errors.length > 0) {
            let isTrue = true
            res.Status.Errors.forEach(e => {
              if (e.ErrorCode == 'S0001' || e.ErrorCode == 'S0002' || e.ErrorCode == 'S0003' || e.ErrorCode == 'S0004') {
                isTrue = false
              }
            })
            if (isTrue == false) {
              that.$confirm('This channel has expired!', '', {
                customClass: 'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
                showCancelButton: false,//去掉取消按钮
                showClose: false,//去掉右上角的取消（X）
                // type: 'warning',
                center: true
              }).then(() => {

              }).catch(() => {

              });
              return false
            }
          } else {
            that.$confirm('failed!', '', {
              customClass: 'custom-message-box', //自定义添加Class
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false,//去掉取消按钮
              showClose: false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {

            }).catch(() => {

            });
          }


        }
      })
    },
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/exp/expEdit.js